import React from "react";

const PageNotFoundBg = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="451.561"
      height="318.476"
      viewBox="0 0 451.561 318.476"
    >
      <defs>
        <clipPath id="clip-path">
          <path
            fill="none"
            d="M0 0H451.561V187.872H0z"
            data-name="Rectangle 3749"
          ></path>
        </clipPath>
      </defs>
      <g data-name="Group 6443" transform="translate(-457.219 -220.524)">
        <text
          fill={fill ? fill : "#d31b61"}
          data-name="404"
          fontFamily="ProximaNova-Bold, Proxima Nova"
          fontSize="97"
          fontWeight="700"
          transform="translate(595.604 510)"
        >
          <tspan x="0" y="0">
            404
          </tspan>
        </text>
        <g data-name="Group 6439" transform="translate(457.219 220.524)">
          <g clipPath="url(#clip-path)" data-name="Group 6438">
            <path
              fill="#d0d0d1"
              d="M0 187.24c2.846-.009 5.694-.077 8.538-.006 1.609.04 2.364-.525 2.235-2.189-.073-.943-.008-1.9-.008-2.845V4.2c0-4.132 0-4.133 4.058-4.133C41.285.066 67.746.116 94.207 0c3.007-.013 3.882.742 3.877 3.818q-.138 88.526-.067 177.052c0 2.108.03 4.215.046 6.323q.319.228.2.441c-.076.139-.151.209-.225.209L0 187.872z"
              data-name="Path 1934"
            ></path>
            <path
              fill="#d31b61"
              d="M631.813 92.484c2.27 7.2 4.611 14.391 5.441 21.946 1.537 13.978 1.531 27.888-2.02 41.621a16.123 16.123 0 01-2.075 5.238 8.034 8.034 0 01-1.724.714c-3.338.688-4.482-.435-4.02-3.915.4-11.645.317-23.264-1.909-34.765a5.452 5.452 0 01-1.089-1.937 49.1 49.1 0 00-2.31-6.107c-3.639 7.668-7.073 15.278-12.55 21.686a36.927 36.927 0 01-17.469 12.846 7.209 7.209 0 01-1.4.18 19.468 19.468 0 01-2.361-.044 3.857 3.857 0 01-1.338-.385c-2.961-1.989-6.351-3.4-8.622-6.332a33.588 33.588 0 01-3.875-7.768 5.655 5.655 0 01-.254-.946c.058-2.621-1.772-5.252.04-7.86 1.079-1.689 2.01-3.5 3.73-4.675 2.222-2.624 4.919-4.795 7.1-7.457l.054-.06a34.061 34.061 0 003.649-3.45c4.22-4.392 8.722-8.537 12.066-13.7a9.512 9.512 0 012.311-2.366 64.514 64.514 0 005.252-4.717l1.3-1.151a36.37 36.37 0 0118.091-.667 4.392 4.392 0 012.2 1.839c.28.318.554.645.847.951a4.97 4.97 0 01.94 1.279"
              data-name="Path 1935"
              transform="translate(-210.617 -32.158)"
            ></path>
            <path
              fill="#287fda"
              d="M551.953 171.972l1.038.006a1.2 1.2 0 01.219 1.279 3.549 3.549 0 01-1.85 1.24c-1.225.452-2.507.713-3.757 1.094a7.95 7.95 0 01-.864.256c-1.083.186-2.12.563-3.2.761-3.254.4-6.455 1.16-9.733 1.384-7.756.051-15.522.231-23.091-1.875-.294-.03-.6-.067-.887-.09-1.765.592-.745 1.332-.051 1.937.855.747 2.162.764 2.924 1.71a1.688 1.688 0 01.037.907c-1.235 1.663-3.071 1.186-4.645 1.086-2.7-.171-4.217.935-5.347 3.345-1.777 3.793-3.643 7.547-5.39 11.355a8.885 8.885 0 00-1.112 3.385c-4.032 7.292-6.668 15.179-9.793 22.858-.659 1.619-1 3.5-3.076 4.069-1.473-.411-3.071-.519-4.215-1.736a37.21 37.21 0 01-1.72-11.891c.007-4.261-.149-8.531.64-12.75a35.146 35.146 0 013.061-9.231c1.793-.849 3.673.032 5.5-.256.8-.126 1.9-.013 1.884-1.132-.015-1.012-1.026-.892-1.7-.736-2.036.468-2.828-1.392-4.211-2.141-.67-1.377 0-2.669.257-3.987a8.872 8.872 0 001.889-3.553 83.763 83.763 0 015.64-14.046 15.713 15.713 0 019.356-7.924c12.171-4.051 24.736-6.015 37.413-7.475l.239.4a15.115 15.115 0 01-.138 3.761c.581-1.563-.4-3.085.745-4.249 1.445 1.317.3 3.086.8 4.573.42 1.238.071 2.662.891 3.812l-.005-.013c.438 2.759 1.882 5.077 3.259 7.424a22.915 22.915 0 008.986 6.444"
              data-name="Path 1936"
              transform="translate(-175.343 -54.991)"
            ></path>
            <path
              fill="#d3dceb"
              d="M369.008 80.016c-.027-10.641-2.762-20.93-4.122-31.4-.727-5.6-1.663-11.166-2.637-16.725-.4-2.294 1.138-1.815 2.287-1.819 8.847-.029 17.694-.015 26.541-.015.7 1.195.494 2.595.88 3.86.249 1.305.346 2.637.668 3.931.264 2.335.975 4.589 1.275 6.918.623 2.637.738 5.367 1.5 7.978a19.581 19.581 0 00.4 3.56c.988 5.771 2.28 11.49 3.038 17.3a2.81 2.81 0 001.837 2.627c12.211-.01 24.424.076 36.633-.1 3.042-.043 4.318.8 3.732 3.862a.685.685 0 01-.759.074 2.426 2.426 0 01-.431-.71c-.108-.261-.2-.526-.3-.788a1.345 1.345 0 00-1.04-.762c-12.042-.061-24.072-.183-36.094.078-1.32.444-1.067 2.3-2.422 2.716-8.3.69-16.613.185-24.918.274-2.032.022-4.234.659-6.08-.862"
              data-name="Path 1937"
              transform="translate(-133.018 -11.031)"
            ></path>
            <path
              fill="#f4b979"
              d="M192.876 116.172c-1.254-1.113-2.778-.6-4.187-.648-5.1-.16-5.061 1.026-4.874-5.043a3.2 3.2 0 012.062-.6c8.979.049 17.96-.184 26.937.122 1.507.953 3.2.856 4.876.869 13.856.11 27.714-.258 41.566.224 1.028.035.2-.962.826-.943 1.373-.759 2.875-.514 4.335-.548 9.261-.209 18.515.247 27.775.289 26 .117 51.992-.543 77.985-.22 7.562.094 15.141-.143 22.694.424 1.527 3.819.968 4.806-2.881 4.8-1.588 0-3.139.323-4.716.311-.554 0-1.053-.21-1.061-.888-.007-.651.426-.888 1.007-.939a28.031 28.031 0 003.374-.111c-19.293-1.288-38.617-.095-56.978-.725 4.492.451 9.944.068 15.385.18a11.257 11.257 0 014.353.587c1.112.482 2.154 1.064 1.431 2.594a2.728 2.728 0 01-2.274.872c-39.5-.643-79.011-.25-118.517-.285-12.643-.011-25.286-.095-37.929-.006a2.125 2.125 0 01-1.188-.309"
              data-name="Path 1938"
              transform="translate(-67.487 -40.233)"
            ></path>
            <path
              fill="#dca96e"
              d="M458.369 126.66c.823 6 1.686 11.986 2.458 17.988 1.32 10.262 2.577 20.532 3.889 30.8a5.177 5.177 0 00.631 1.384 1.8 1.8 0 01.2.966 13.647 13.647 0 00.315 4.685c.685 2.179-1.411 4.744-.705 5.921 1.1 1.826 2.082 3.474 2.187 5.581.187 3.767.512 7.524.78 11.284.193 2.7 1.117 5.33.752 8.081a2.783 2.783 0 00-1.008 2.447c.093-.734-.049-1.49.642-1.934 2.245.955 1.834 3.421 1.391 4.547-1.379 3.51-.309 5.991 2.142 8.317a4.338 4.338 0 01.061 2.969 1.147 1.147 0 01-1.215.781c-2.121.03-3.155-.928-3.4-3.123a37.682 37.682 0 00-.9-5.2 78.119 78.119 0 00-1.2-8.531 11.383 11.383 0 00-1.247-3.639 65.964 65.964 0 01-1.165-7.588 4.763 4.763 0 01-.027-.921 5.968 5.968 0 00-.113-3.468 6.011 6.011 0 01-.184-.883 8.4 8.4 0 01.226-3.54c.116-.316.476-.416.641-.7-.292.162-.583.325-.915.05-1.432-3.245-1.345-6.768-1.874-10.169-.118-.76-.25-1.276-.94-1.6-1.744-4.914-1.918-10.12-2.787-15.189-2.223-12.969-4.061-26-6.316-38.968a9.045 9.045 0 01-.007-3.761 1.81 1.81 0 01.873-1.149c.161.1.746.179.734.106a3.638 3.638 0 01.109-1.558c.288-1.045.623-2.131 2.018-1.942 1.226.166 1.305 1.191 1.322 2.168a5.213 5.213 0 00.239 2.6c.765-1.9-1.566-4.428 1.286-5.726 7.552-.664 15.107-.259 22.658-.239a2.62 2.62 0 012.666 1.316c.267 2.424-1.527 2.094-2.933 2.106-5.682.047-11.364.016-17.046.02-5.1 0-5.351.345-4.232 5.71"
              data-name="Path 1939"
              transform="translate(-165.445 -43.105)"
            ></path>
            <path
              fill="#dda86e"
              d="M363.971 118.489c-.1 2.353 1.3 4.626.3 7.27-1.595-1.2-2.568-2.405-1.778-4.465.289-.756.518-1.818-.683-1.991-1.039-.149-.9.895-1.072 1.562q-.266 1.056-.567 2.1c-.083.286-.027 1.085-.554.234-.146-.234-.059-.612-.078-.923a8.786 8.786 0 00-7.512-1.324 4.741 4.741 0 01-1.87.245c-5.617-.848-11.275.534-16.912-.4-2.571-.427-5.2.884-7.828.4-5.436-.993-10.913-.482-16.372-.552a51.911 51.911 0 00-11.007.509c-3.045.612-6.049-.534-9.1-.534q-24.475 0-48.951.009c-4.951.005-6.154 1.007-6.645 5.971-.281 2.844-1.237 5.531-1.549 8.361a5.526 5.526 0 01-2.415 3.92c-1.5 1.075-2.278 2.33-1.142 4.258.945 1.607.729 3.5.472 5.257-.213 1.466-.841 2.826-2.677 1.5-.381-.275-.149-.544-.333.08a2.77 2.77 0 01-3.731 1.918c-1.632-.759-1.448-2.774-1-4.46a185.551 185.551 0 013.094-19.493 1.672 1.672 0 00.473-.776c1.367-6.026 1.267-6.155-4.888-6.157-6.081 0-12.162.042-18.242-.037-1.143-.015-3.045.571-2.533-1.868.937-1.026 2.173-.607 3.279-.607q75.161-.031 150.323-.088c1.932 0 3.87 1.383 5.8.054a4.788 4.788 0 015.694.023"
              data-name="Path 1940"
              transform="translate(-73.009 -43.168)"
            ></path>
            <path
              fill="#dca86e"
              d="M612.228 190.086l24.791 66.185c-1.05 1.8-2.269 1.157-3.507.246.133-.4-.137.09-.012-.308a4.792 4.792 0 01.669-1.007c-.168.161-.284.369-.478.531a.85.85 0 01-.835.042c-2.776-3.76-4.222-8.191-6.187-12.348-7.016-14.833-13.827-29.761-20.679-44.67a10.239 10.239 0 00-3.2-4.218c-.4-1.427.878-1.414 1.6-1.879a6.443 6.443 0 01.885-.266 12.419 12.419 0 004.205-1.738c.823-.471 1.63-1.357 2.743-.571"
              data-name="Path 1941"
              transform="translate(-221.356 -69.697)"
            ></path>
            <path
              fill="#dda86f"
              d="M226.142 148.6a4.865 4.865 0 00.16 1.865c.389.726.118 2.473 1.228 2.017 1.077-.443 3.318-.009 3.086-2.358a4.546 4.546 0 01.009-.946c.061-.561-.163-1.45.9-1.126.809.247.846.774.272 1.411s-.786 1.4.33 1.609c.814.151 1.078-.618.985-1.262-.285-1.967.709-3.993-1.048-5.937-1.333-1.475.1-3.757 1.325-4.263 2.371-.976 2.559-2.73 2.926-4.666.659-3.484 1.391-6.955 2.026-10.444.493-2.71 2.4-3.558 4.77-3.563 17.579-.037 35.173-.442 52.73.175 7.671.27 15.255-.779 22.9-.27a101.429 101.429 0 0012.85.518c5.4-.336 10.782.237 16.2-.153 4.162-.3 8.493.037 12.768-.2 1.579-.087 3.753-.037 4.147 2.433l-.685.751c-4.2-1.276-8.517-1.052-12.822-1.052q-51.688.009-103.377 0c-1.054 0-2.108-.018-3.161.011-3.588.1-4.091.47-4.875 4.024-3.177 14.4-6.034 28.871-9.058 43.306-1.338 6.387-2.444 12.827-4.227 19.116-.674.971-.649 2.447-2.051 2.9a16.2 16.2 0 01-2.582-6.307c-.439-1.8-.214-3.568 2.06-4.3 1.7-.55 2.184-1.863 1.663-3.528a3.673 3.673 0 01.425-3.212c2.142-3.815 3.762-7.8.037-11.887-1.364 1.069-1.491 2.622-1.581 4.168-.179 3.074-1.585 6.145.131 9.237.437.788-.263 1.6-.857 2.223a7.038 7.038 0 00-1.956 5.8c.359 3.3-2.009 6.56-.065 9.857.206.35.168.978-.3 1.072-2.634.531-1.915 2.617-1.994 4.272a23.253 23.253 0 01-.89 4.631c-.449 1.762-.627 3.489.553 5.132 1.02 1.42 1.05 2.756-.855 3.539-.613.252-1.218.606-1.226 1.3-.037 3.424-2.787 6.835-.009 10.3.454.565.3 2-.148 1.987-2.173-.049-2.206 2.613-3.994 2.892.813-8.981 2.688-17.8 4.062-26.7 2.318-15.008 4.909-29.974 7.4-44.955a12.553 12.553 0 01.559-1.755c.349.138.313.662.732.729.036-.334.271-.635.166-.993-.216.358-.469.609-.909.311a22.646 22.646 0 011.264-7.707"
              data-name="Path 1942"
              transform="translate(-78.178 -44.329)"
            ></path>
            <path
              fill="#fdc4ae"
              d="M649.556 76.133a86.121 86.121 0 00-13.5-.722 20.453 20.453 0 00-5.276.621c.63-1.272 1.831-1.218 2.98-1.279 4.584-.246 6.748-3.816 4.878-8.15a32.215 32.215 0 00-1.841-3.273c-1.647-2.844-1.2-4.52 1.631-6.256 1.767-1.085 4.186-1.155 4.993-3.764.326-1.055 1.676.027 2.565.019 1.852-.018 3.972 1.134 5.217-1.3 2.049.719 2.066 3.037 3.408 4.315 1.067 2.147 3.529 3.2 4.358 5.534-.067 1.413-1.153 1.553-2.182 1.679a6.312 6.312 0 00-3.7 1.334c-.46.545-.286.872.374.964a4.069 4.069 0 012.732 1.017 2.531 2.531 0 01.422.836 2.6 2.6 0 01-1.742 3.111 3.844 3.844 0 01-2.334.091c-2.6-1.095-2.251 1.112-2.671 2.411-.294.907.907 2-.319 2.813"
              data-name="Path 1943"
              transform="translate(-231.665 -19.108)"
            ></path>
            <path
              fill="#dda86e"
              d="M212.46 253.334c1.284-.853.184-4.278 3.485-3.152.41.14.4-1.557-.254-2.01-1.919-1.319-1.581-3.292-1.1-4.851a17.1 17.1 0 001.1-6.127c-.068-1.119.454-1.522 1.574-1.133.656.228 1.269.113 1.459-.7a1.172 1.172 0 00-.439-1.4c-2.505-1.319-1.524-3.676-1.1-5.308a30.481 30.481 0 001.055-7.753c0-1.574.03-3.546 3.005-1.779-3.64-3.5-.343-6.811-.519-10.074-.147-2.735-.437-5.8 2.678-7.525.265-.147.513-.954.382-1.094-3.48-3.735.278-7.7-.32-11.55-.15-.961 1.107-2.178 1.8-3.22.414-.621 1.42-.724 1.484-.055.3 3.11 4.113 5.63 1.262 9.366-1.079 1.415.27 4.312-2.555 5.081-.037.01-.075.227-.031.3 2.381 3.848.423 5.367-3.067 6.89-1.271.555-.254 3.224.551 4.634a7.348 7.348 0 01.991 4.187c1 1.072.723 2.289.428 3.525a17.26 17.26 0 00-.816 5.829c-1.088 7.536-2.976 14.91-4.588 22.338-.606 1.746-.778 3.6-1.275 5.375a5.28 5.28 0 01-.283.83 3.721 3.721 0 01-1.681 1.868l-2.569-.008c-.363-.4-1.023-.12-1.353-.594q.349-.942.7-1.883"
              data-name="Path 1944"
              transform="translate(-77.772 -67.995)"
            ></path>
            <path
              fill="#d3dceb"
              d="M244.967 79.2c-.036 1.751 1.209 1.76 2.364 1.582 3.078-.476 3.435.842 2.755 3.489-.943 3.672-1.153 7.522-2.58 11.09-2.6 2.52-5.851 2.192-9.055 2.086-1.66-.056-2.692-.528-2.7-2.554-.005-2.58-.85-5.092-1.057-7.673-.034-.42.189.042-.023-.285s-.308.158-.471.257c-.964-2.422-1.743-4.86-.664-7.464.537-.618 1.093-.078 1.641-.032 2.844.277 5.726 1.085 8.417-.639a2.391 2.391 0 01.8-.357.528.528 0 01.566.5"
              data-name="Path 1945"
              transform="translate(-85.579 -28.904)"
            ></path>
            <path
              fill="#1a2439"
              d="M610.538 177.551c-2.38.854-4.275 2.811-6.928 3.042-.226-.149-.306-.607-.728-.344a.661.661 0 01.335.4l-1.92 1.066a1.615 1.615 0 01-.707.6c-2.224.411-3-.023-2.122-2.548a15.811 15.811 0 012.609-5.471 43.1 43.1 0 0017.073-12.734c.606 1.423 2.449.471 3.178 1.656-.144-2.058 2.351-1.682 2.932-3.212a15.873 15.873 0 011.909-3.189c.788-1.143 1.819-1.822 2.92-.231a45.678 45.678 0 01-11.277 14.76c-2.442 2.037-4.746 4.261-7.275 6.212"
              data-name="Path 1946"
              transform="translate(-219.666 -57.162)"
            ></path>
            <path
              fill="#f3bb79"
              d="M441.342 116l-5.694-.022c-.878-2.146-2.809-1.843-4.527-1.862-6.813-.077-13.637.233-20.422-.664-.4-.053-.792-.168-1.242-.265.373-1.537 1.542-.952 2.309-.954q25.553-.058 51.1-.02a4.494 4.494 0 012.152.268 6.331 6.331 0 007.084-.04 2.306 2.306 0 012.67.206.832.832 0 01.167.788c-.54.871-1.469.592-2.279.668-1.67.159-3.434-.354-4.979 1.047a48.549 48.549 0 007.506-.625c1.736-.4.666-2.347.939-3.581a.424.424 0 01.687-.013 12.232 12.232 0 00.071 1.24c.451 2.9-.582 4.136-3.688 3.865-1.764-.154-3.734-.694-5.408.59-.175.294-.348.278-.519 0-.93-1.033-2.164-.6-3.266-.609-7.556-.034-15.111-.015-22.667-.013"
              data-name="Path 1947"
              transform="translate(-150.379 -40.678)"
            ></path>
            <path
              fill="#d4dceb"
              d="M216.17 91.063v-1.824a18.85 18.85 0 011.9 8.731c-.118 1.865.535 2.812 2.48 2.527 2.872-.421 6.313 1.412 8.4-2.362.34-.616.266.733.523 1.1-.831 2.364.626 2.567 2.382 2.564 9.228-.012 18.458-.006 27.861-.006.355-.8-2.528-2.789.532-2.468 3.331.35 3.649-1.383 3.393-3.882 2.278 3.666 5.948 2.755 9.337 2.911 1.737.08 3.527-.659 5.216.278.863 1.131 2.214.271 3.255.808.131 1.11-1.14 1.417-1.371 2.32a2.7 2.7 0 01-2.147.948c-19.633.208-39.268 1.164-58.891.489-11.229-.386-22.448-.394-33.672-.488a1.757 1.757 0 01-1.452-.416c1.006-.841 2.209-.483 3.325-.486 9.108-.029 18.218-.115 27.323.041 2.8.048 3.263-1.122 2.722-3.4a25.873 25.873 0 01-1.117-7.384"
              data-name="Path 1948"
              transform="translate(-67.546 -32.774)"
            ></path>
            <path
              fill="#a7aeba"
              d="M324.233 97.812c-4.068 1.183-8.232.509-12.351.581-2.687.047-.785-2.9-2.2-3.771-.008-.208 0-.418-.028-.624-.845-6.907-.845-6.907 6.093-6.907a33.426 33.426 0 004.37-.04 3.184 3.184 0 013.494 1.853c.4.763-.371 1.26-.423 1.921-.17.8-.361 1.587-.494 2.386-.436 2.614-.3 2.709 2.39 1.868.686.327.89.786.394 1.436l-1.243 1.3"
              data-name="Path 1949"
              transform="translate(-113.584 -31.956)"
            ></path>
            <path
              fill="#283041"
              d="M665.387 73.845c.964-.809 1.928-1.618 1.343-3.1.1-.308.281-.709.545-.712 5.3-.068 8.455-3.24 10.912-7.448.461-.79.98-1.4 1.985-.755.886 1.879 1.538 3.781.569 5.841-.576-.609-.326-1.369-.386-2.254-.015.9-.187 1.645.386 2.255-1.308 3.536-3.722 6.41-5.717 9.534-1.415-1.009-2.66-.74-3.949.342a7.4 7.4 0 01-7.026 1.47 3.353 3.353 0 00-.9.116c-.431.18-.2.365.034.6.969.967.389 2.115.331 3.2-.441-.189-1.005-.218-1.115-.845a.747.747 0 00-.673-.712c-1-.156-1.3-.912-1.516-1.744a7.537 7.537 0 01.091-5.222c.714-2 1.526-1.917 2.785-.608a1.571 1.571 0 002.3.042"
              data-name="Path 1950"
              transform="translate(-242.315 -22.608)"
            ></path>
            <path
              fill="#182238"
              d="M640.584 146.5c-1.214-.52-1.748-.388-2.58 1.021-1.05 1.779-1.417 4.487-4.308 4.815-1.084.123-.083.724-.031 1.093.116.838-.163 1.578-.966 1.694-1.312.19-.8-.737-.76-1.447.047-.909-.63-.977-1.293-.737-2.287.826-.637-1-1-1.463a93.634 93.634 0 0012.84-23.276 24.738 24.738 0 013.014 8.115 2.277 2.277 0 01-.673 1.863c-1.582 2.688-2.322 5.8-4.243 8.32"
              data-name="Path 1951"
              transform="translate(-231.158 -47.084)"
            ></path>
            <path
              fill="#edc190"
              d="M183.891 109.415l94.9.084a3.934 3.934 0 012.161-.275c2.318-.015 4.637-.038 6.955 0 27.272.442 54.536-1.009 81.8-.463 8.06.161 16.156.068 24.211.752l.046.637-.687.013-133.462.01c-1 .826-2.2.6-3.338.606q-20.064.025-40.129 0c-1.141 0-2.339.193-3.34-.614l-29.156-.018.043-.732"
              data-name="Path 1952"
              transform="translate(-67.521 -39.898)"
            ></path>
            <path
              fill="#f8d2a3"
              d="M655.978 199.026c-.288 5.019 3.574 2.592 5.745 3.2-1.007 4.236-.936 8.672-2.532 12.814-.583 1.513-1.245 2.637-2.921 2.848-2 .252-3.073-.564-2.732-2.661.231-1.421.936-2.783.423-4.274-1.128-.239-1.122 1.626-2.712 1.045 1.046-4.486 5.088-8 4.729-12.971"
              data-name="Path 1953"
              transform="translate(-239.181 -73.095)"
            ></path>
            <path
              fill="#19253b"
              d="M665.679 53.094c-1.593-1.1-1.783-3.076-2.825-4.518-.019-1.525-.977-3.117.323-4.551a2.314 2.314 0 01.363 2.078 2.1 2.1 0 00-.347-2.103c.615-1.113 1.627-1.97 2.594-.821 1.278 1.519 3.085 1.461 4.606 2.2a4.138 4.138 0 01-.33.533.973.973 0 00.925.013 3.2 3.2 0 00.545-.432c.545-.1 1.029-.048 1.292.534a7.145 7.145 0 002.468 2.3 3.457 3.457 0 011.441 3.587c-.289 1.333-1.577 1.151-2.564 1.307a8.281 8.281 0 00-2.639.941 4.264 4.264 0 01-5.852-1.06"
              data-name="Path 1954"
              transform="translate(-243.311 -15.657)"
            ></path>
            <path
              fill="#2468be"
              d="M473.469 208.426a.653.653 0 00.281-.506l7.621-5.9c1.251 1.295-.136 2.51-.113 3.768a4.982 4.982 0 01-1.266 4.427l-2.53 8.852c-1.311 1.474.109 3.967-1.932 5.168-.381-.587-.289-1.3-.523-1.927a6.944 6.944 0 00-.8-3.425c.083-3.509-1.231-6.922-.735-10.46"
              data-name="Path 1955"
              transform="translate(-173.847 -74.196)"
            ></path>
            <path
              fill="#222c3d"
              d="M681.93 59.975c-.3.086-.843.135-.863.264-.692 4.412-4.964 5.417-7.585 7.975-1.131 1.1-2.423 2.263-3.876.259-.062-.086-.731.268-1.117.417l.011-.017c-.585-1.221-1.708-.962-2.709-.943-1.224.023-1.377-.614-1.1-1.588a4.621 4.621 0 014.578-2.153c.756.084 1.806.451 1.744-1 3.418-.173 4.909-3.139 6.387-5.3 1.69-2.476 2.174-1.106 3.2.079 1.04.273 1.275 1.081 1.332 2.006"
              data-name="Path 1956"
              transform="translate(-244.074 -20.753)"
            ></path>
            <path
              fill="#d4d3d6"
              d="M217.959 295.761l1.214-1.868a59.946 59.946 0 007.244.258q50.329 0 100.657.014c1.876 0 3.8-.27 5.6.573a.769.769 0 01.391 1.041l-115.1-.018"
              data-name="Path 1957"
              transform="translate(-80.049 -107.936)"
            ></path>
            <path
              fill="#ecdccc"
              d="M449.02 109.14l-115.128-.013a1.379 1.379 0 011.268-.616h23.457l31.644-.043c1.143-1.033 2.565-.826 3.915-.829q15.971-.033 31.94 0c1.357 0 2.769-.155 3.917.849q.311.01.623.006c5.137.013 10.273.01 15.409.056 1 .009 2.124-.357 2.956.592"
              data-name="Path 1958"
              transform="translate(-122.627 -39.526)"
            ></path>
            <path
              fill="#d0cfd3"
              d="M598.819 294.007c.811 1.96 2.037 1.4 3.312.545l.576.585q.485.382-.036.712l-94.88-.033a.756.756 0 01.387-1.03c1.689-.809 3.5-.574 5.275-.575q37.361-.027 74.721-.009c3.362 0 6.724.01 10.083-.185a3.643 3.643 0 00.569-.006z"
              data-name="Path 1959"
              transform="translate(-186.468 -107.978)"
            ></path>
            <path
              fill="#5bcf8d"
              d="M237.251 50.119a2.091 2.091 0 00.1.595 18.007 18.007 0 012.15 4.849 3.484 3.484 0 01.039.885c-.135.882-.587 1.751-.056 2.548.117-1.645.589-3.228 2.33-4.1a1.533 1.533 0 01.882.222c1.4 1.364 1.029 3 .721 4.632-.245 1.3-.8 2.561-.618 3.932a3.106 3.106 0 01-.1 1.334c-.652.91-1.238 1.952-2.659 1.455a2.5 2.5 0 01-.532-.455.58.58 0 00-.8-.158 1.17 1.17 0 01-1.006.18 4.659 4.659 0 01-2.294-2.714l-1.44-1.844c-.447-.685-1.965-.941-.9-2.235a1.84 1.84 0 012.258.354l.095-.062a13.453 13.453 0 00.983 1.014.5.5 0 00.407.263 4.769 4.769 0 00-.051-.552c.007-.876.538-1.76-.116-2.594-.68-2.3-.2-4.645-.267-6.968-.013-.454.394-.656.866-.579"
              data-name="Path 1960"
              transform="translate(-85.463 -18.401)"
            ></path>
            <path
              fill="#1d283c"
              d="M681.682 54.84c-1.284.661-.845-1.052-1.849-1.178.292 3.745-5.614 3.555-4.761 7.993a4.811 4.811 0 00-2.975-1.591 15.189 15.189 0 01-4.571-5c2.1 1.2 4.187 1.69 6.239-.1a3.489 3.489 0 012.036-.613c.731-.094 1.934.517 2.087-.582a3.084 3.084 0 00-1.053-3.07c-.9-.7-2.835-.717-2.162-2.708 3.3 1.3 6.051 3.161 7.01 6.854"
              data-name="Path 1961"
              transform="translate(-245.159 -17.624)"
            ></path>
            <path
              fill="#dead79"
              d="M198.6 120.018c.3 1.743 1.681 1.252 2.732 1.257 6.376.034 12.754-.035 19.13.055 1.547.022 3.846-.916 4.427 1.157s1.1 4.575-1.1 6.368c.039-.736.037-1.476.123-2.206.495-4.218.5-4.22-3.92-4.223-6.425 0-12.85-.022-19.275.008-1.691.008-3.026-.217-2.6-2.416q.24.009.48 0"
              data-name="Path 1962"
              transform="translate(-72.733 -44.078)"
            ></path>
            <path
              fill="#afb5c0"
              d="M419.824 90.2c-1.084-.057-2.432.4-2.6-1.388-.6-6.3-2.416-12.435-2.6-18.794-.158-.783-.913-1.77.673-1.953z"
              data-name="Path 1963"
              transform="translate(-152.16 -24.997)"
            ></path>
            <path
              fill="#dfaf7d"
              d="M486.434 120.022q.26.007.519 0c.389 2.154-.913 2.425-2.6 2.416-5.536-.029-11.072-.011-16.607-.01-5.344 0-5.344 0-5.288 5.2-1.353-1.55-.678-3.4-.6-5.091.076-1.729 1.67-1.221 2.713-1.228 6.377-.042 12.754 0 19.131-.041 1.046-.006 2.439.5 2.731-1.253"
              data-name="Path 1964"
              transform="translate(-169.538 -44.08)"
            ></path>
            <path
              fill="#cecfd2"
              d="M399.874 295.645v-.6c1-1.052 2.385-.716 3.6-1.005a18.661 18.661 0 012.991.033c5.937.043 11.871-.028 17.8.04a37.728 37.728 0 005.885-.587c4.557 1.113 9.2.428 13.8.63 1.669.122 3.391-.267 4.99.519a.684.684 0 01.27.96l-49.332.006"
              data-name="Path 1965"
              transform="translate(-146.858 -107.803)"
            ></path>
            <path
              fill="#333945"
              d="M666.524 86.954c3.111.473 5.435-1.147 7.68-2.924 1.709-1.353 2.858-1.217 3.294 1.112-.852 2.625-3.254 2.71-5.278 2.757a11.763 11.763 0 01-5.7-.945"
              data-name="Path 1966"
              transform="translate(-244.791 -30.543)"
            ></path>
            <path
              fill="#d2d2d4"
              d="M190.894 295.877l1.355.594-37.3.026.023-.65 35.925.03"
              data-name="Path 1967"
              transform="translate(-56.906 -108.654)"
            ></path>
            <path
              fill="#d1d1d3"
              d="M657.784 296.5l.036-.711h35.319v.712z"
              data-name="Path 1968"
              transform="translate(-241.581 -108.634)"
            ></path>
            <path
              fill="#cfd1d0"
              d="M477.842 295.659v-.561a3.726 3.726 0 013.129-.1l.73-.571c3.481-.742 7.113.413 10.549-.842 1.27.051 2.438.769 3.751.588a1.139 1.139 0 01.813.914v.574h-18.976"
              data-name="Path 1969"
              transform="translate(-175.494 -107.823)"
            ></path>
            <path
              fill="#bcbfc6"
              d="M333.085 97.615a1.3 1.3 0 00-.631-1.257c-.878-1.627-.265-3.994-2.465-4.965L331.217 90c3.629 1.59 4.208 3.95 1.868 7.611"
              data-name="Path 1970"
              transform="translate(-121.193 -33.055)"
            ></path>
            <path
              fill="#7ae3a7"
              d="M256.46 59.594l-.668 1.874c-.838.714-1.069 1.806-1.664 2.674-.8.755-1.245 1.834-2.222 2.427-1.424-.178-1.147-1.437-1.477-2.313a1.991 1.991 0 01.094-.838 2.045 2.045 0 01.6-.551 2.177 2.177 0 001.453-1.632 3.579 3.579 0 01.463-1.117 16.808 16.808 0 011.7-1.24 1.591 1.591 0 01.838-.152 1.279 1.279 0 01.889.87"
              data-name="Path 1971"
              transform="translate(-91.97 -21.565)"
            ></path>
            <path
              fill="#84dea8"
              d="M254.925 70.743c-.19.361-.634.831-.532 1.066 1.52 3.524-1.536 3.323-3.324 4.151l.03-.308c-.657-.854 1.357-1.2.383-2.108a7.122 7.122 0 01-1.689-.847.98.98 0 01-.137-.776 1.636 1.636 0 01.643-.5 4.068 4.068 0 011.2-.192 5.45 5.45 0 002.1-1.091c.628-.211 1.379-.678 1.319.6"
              data-name="Path 1972"
              transform="translate(-91.68 -25.664)"
            ></path>
            <path
              fill="#8fddb0"
              d="M242.509 53.841c.016-.2.029-.4.037-.594-.061-1.653-1.085-3.25-.289-4.956.473-1.709-1.052-3.777.941-5.209.267 1.448-.257 3.018.663 4.367.347 1.316.561 2.664.922 3.978.016.154.028.308.044.463a2.226 2.226 0 01-.295.871c-.51.668-.691 1.954-2.024 1.079"
              data-name="Path 1973"
              transform="translate(-88.861 -15.823)"
            ></path>
            <path
              fill="#babfc9"
              d="M413.031 60.962a28.6 28.6 0 01-1.252-8.257c-.232-.675.082-.8.664-.662l1.29 6.942c-.523.556.121 1.527-.7 1.976"
              data-name="Path 1974"
              transform="translate(-151.203 -19.095)"
            ></path>
            <path
              fill="#e2626a"
              d="M587.741 130.175c-1.686 3.134-4.358 5.329-7.1 7.457a31 31 0 017.1-7.457"
              data-name="Path 1975"
              transform="translate(-213.248 -47.809)"
            ></path>
            <path
              fill="#5dcb8f"
              d="M256.719 53.759l1.725-3.949c.91-.241 1.133.409 1.365 1.048a3.294 3.294 0 01-.06 1.448c-.554 1.281-.96 2.671-2.365 3.356l-.042.024c-1.417-.252-.936-1.117-.624-1.928"
              data-name="Path 1976"
              transform="translate(-94.16 -18.275)"
            ></path>
            <path
              fill="#bfc5ce"
              d="M411.712 48.009l-.664.661a15.693 15.693 0 01-1.255-6.971c-.24-.666.072-.781.64-.64.2 2.359 1.382 4.535 1.279 6.949"
              data-name="Path 1977"
              transform="translate(-150.472 -15.06)"
            ></path>
            <path
              fill="#597ac3"
              d="M574.391 157.954c-1.567-1.193-1.209-2.933-1.36-4.561-.109-1.171.577-2.51-.612-3.5a.342.342 0 01-.527.011l-.041-.249c.542-.495 1.2-.359 1.832-.331l.709 8.627"
              data-name="Path 1978"
              transform="translate(-210.02 -54.828)"
            ></path>
            <path
              fill="#e3f7ee"
              d="M252.543 46.55c-.425-.813-1.19-1.841.31-2.168 1-.217 1.029.885.967 1.591-.171 1.951.562 3.991-.55 5.85a1.664 1.664 0 01-.624-.779c-.514-1.486.075-3-.1-4.494"
              data-name="Path 1979"
              transform="translate(-92.538 -16.29)"
            ></path>
            <path
              fill="#7dcda2"
              d="M229.446 49.07c.526 1.636 2.313 2.577 2.444 4.431-.65-.01-.957.5-1.342.893a1.548 1.548 0 01-.8 0 1.37 1.37 0 01-.726-.974c-.041-.819.468-1.682-.2-2.45l-.1-1.14c-.245-.721.112-.863.728-.756"
              data-name="Path 1980"
              transform="translate(-83.972 -18.01)"
            ></path>
            <path
              fill="#cdf3db"
              d="M239.1 48.857c-1.4 2.421-.183 5.049-.6 7.547-1.412-3.148-.344-6.36-.736-9.737 1.608.5 1.322 1.409 1.336 2.189"
              data-name="Path 1981"
              transform="translate(-87.315 -17.139)"
            ></path>
            <path
              fill="#8adbaa"
              d="M251.616 47.825c1.246 1.363.357 3.012.607 4.509a.45.45 0 01-.612.211c-.849-.756-.738.477-1.183.585a.86.86 0 01-.792-.193.913.913 0 01.068-1.2c.73-1.259.533-2.969 1.912-3.911"
              data-name="Path 1982"
              transform="translate(-91.612 -17.564)"
            ></path>
            <path
              fill="#eefaf3"
              d="M255.891 65.6c-.051-1.355.383-2.348 1.9-2.533.078 1.326 1.081 1.26 2 1.326.09.9-.638 1.228-1.182 1.688a3.049 3.049 0 01-1.665.623c-.609-.121-1.251-.213-1.046-1.1"
              data-name="Path 1983"
              transform="translate(-93.965 -23.161)"
            ></path>
            <path
              fill="#df606b"
              d="M625.643 91.783a14.687 14.687 0 01-5.222 5.168.943.943 0 01.25-1.2c1.645-1.336 3-3.038 4.972-3.963"
              data-name="Path 1984"
              transform="translate(-227.819 -33.709)"
            ></path>
            <path
              fill="#c0fcda"
              d="M241.853 51.721c-.428 1.486.844 2.974-.009 4.459-.848-1.616-1.88-3.168-1.794-5.113l1.171.632c.221-.309.432-.288.632.022"
              data-name="Path 1985"
              transform="translate(-88.16 -18.755)"
            ></path>
            <path
              fill="#7ed0a0"
              d="M256.755 67.567l1.214-.69c.83-.377 1.439-.351 1.441.787-.778.764-1.405 1.738-2.622 1.9-.382-.778-.875-.206-1.33-.109a.456.456 0 01-.731.005c-.229-1.6 1.25-1.369 2.029-1.889"
              data-name="Path 1986"
              transform="translate(-93.543 -24.482)"
            ></path>
            <path
              fill="#9fe1be"
              d="M242.536 47.529c-.211-.013-.421-.02-.632-.021l.02-7.563a.779.779 0 011.23.02l.025 1.858c-1.288 1.781-.325 3.815-.643 5.705"
              data-name="Path 1987"
              transform="translate(-88.843 -14.564)"
            ></path>
            <path
              fill="#d9ede5"
              d="M227.633 52.086c.826.692.7 1.629.66 2.546-.422.433-.65 1.067-1.307 1.256a12.334 12.334 0 01-1.035-1.511c-.258-.516-.865-1.133-.314-1.679.714-.707.953.432 1.4.525 1.055.22.348-.763.594-1.138"
              data-name="Path 1988"
              transform="translate(-82.787 -19.129)"
            ></path>
            <path
              fill="#f2fbf7"
              d="M226.33 67.938c-.537-.308-1.223-.621-.948-1.364a1.066 1.066 0 011.6-.388c1.028.575 2.387.914 2.473 2.465-1.352 1.121-1.906-1.254-3.126-.712"
              data-name="Path 1989"
              transform="translate(-82.752 -24.235)"
            ></path>
            <path
              fill="#f2fbf7"
              d="M231.482 63.14l1.1 1.892c-2.366-.851-3.34-2.714-3.667-5.045a.645.645 0 01.755-.152 15.9 15.9 0 012.061 2.117 1.122 1.122 0 01-.247 1.188"
              data-name="Path 1990"
              transform="translate(-84.071 -21.953)"
            ></path>
            <path
              fill="#c4e6d4"
              d="M248.209 53.434l.078 1.312c-.089.1-.177.205-.264.309a2.83 2.83 0 01-2.29.307h-.006a2.383 2.383 0 01.009-2.513c1.074-.868 1.782-.179 2.473.581"
              data-name="Path 1991"
              transform="translate(-90.117 -19.262)"
            ></path>
            <path
              fill="#8ce4b3"
              d="M232.659 63.185l-.1-1.1a2.235 2.235 0 01-.442-1.206 1.862 1.862 0 01.275-.785c1.3-.775 1.34 1.015 2.22 1.1a1.882 1.882 0 01.507 2.009l-2.461-.011"
              data-name="Path 1992"
              transform="translate(-85.249 -21.997)"
            ></path>
            <path
              fill="#d0f3e1"
              d="M252.473 55.085a2.6 2.6 0 00.541-.132l.12.763c-.027.681-.17 1.4.565 1.845a.889.889 0 01.066 1.26l-.1 1.212c-.6 1.016-1.21.976-1.713-.044a6.2 6.2 0 01-.326-2.972 2.589 2.589 0 01.847-1.932"
              data-name="Path 1993"
              transform="translate(-92.403 -20.182)"
            ></path>
            <path
              fill="#d7f5e5"
              d="M236.1 71a8.711 8.711 0 012.475 2.594c.225.516-.083.7-.5.819a6.683 6.683 0 01-2.223-.886 2.939 2.939 0 01-1.205-1.052.806.806 0 01.091-.761c.542-.074 1.083-.148 1.367-.714"
              data-name="Path 1994"
              transform="translate(-86.157 -26.075)"
            ></path>
            <path
              fill="#7bcb9f"
              d="M236.018 74.295l2.177.956a1.256 1.256 0 01.245.864 1.515 1.515 0 01-.466.778 1.205 1.205 0 01-1.3-.149l-1.948-1.877c.25-.592.832-.438 1.286-.572"
              data-name="Path 1995"
              transform="translate(-86.209 -27.286)"
            ></path>
            <path
              fill="#79dba4"
              d="M257.967 57.24l1.818-3.188a1.306 1.306 0 01.5.6c.3.63-.22 1.3.087 1.928-.028.74-.627.981-1.137 1.3l-1.265-.64"
              data-name="Path 1996"
              transform="translate(-94.742 -19.851)"
            ></path>
            <path
              fill="#86d1a7"
              d="M260.528 49.9a1.806 1.806 0 00-.886-1.509q.646-1.237 1.294-2.472c.737-.121 1.112.112.9.919l-.184 1.648c-.327.51-.055 1.5-1.128 1.414"
              data-name="Path 1997"
              transform="translate(-95.357 -16.852)"
            ></path>
            <path
              fill="#b5bbc5"
              d="M413.8 65.022c.077-.714-.089-1.514.7-1.975a5.608 5.608 0 01.609 3.173c-.763.465-.6 1.248-.673 1.953-.938-.9-.5-2.085-.638-3.15"
              data-name="Path 1998"
              transform="translate(-151.975 -23.155)"
            ></path>
            <path
              fill="#e8f5ed"
              d="M242.806 38.506l-1.231-.02a.9.9 0 01.089-.3c.721-.939-1.746-2.193-.175-2.477 1.72-.31 1.217 1.654 1.317 2.794"
              data-name="Path 1999"
              transform="translate(-88.494 -13.104)"
            ></path>
            <path
              fill="#7ccc9b"
              d="M233.013 71.576q.075.264.156.527c-.28.623-.869.688-1.434.8-.714-.312-1.489-.54-1.841-1.346 0-1.093.565-1.072 1.324-.679l1.8.7"
              data-name="Path 2000"
              transform="translate(-84.432 -25.939)"
            ></path>
            <path
              fill="#dcfae9"
              d="M260.969 51.406l1.128-1.413c.444.6 1.4 1.041.643 2.023-.538.455-.663 1.6-1.79 1.067a.9.9 0 00-.109-.523l.128-1.155"
              data-name="Path 2001"
              transform="translate(-95.798 -18.361)"
            ></path>
            <path
              fill="#c6cdd7"
              d="M410.064 38.864l-.64.64c-1.105-1.119-.432-2.53-.622-3.8-.268-.665.056-.757.608-.626l.654 3.786"
              data-name="Path 2002"
              transform="translate(-150.103 -12.864)"
            ></path>
            <path
              fill="#a9dabd"
              d="M261.305 66.7a1.575 1.575 0 00-1.441-.786q.7-.585 1.393-1.168l1.171-.7c1.057.026 1.119.5.573 1.26l-1.7 1.4"
              data-name="Path 2003"
              transform="translate(-95.439 -23.523)"
            ></path>
            <path
              fill="#77cc9b"
              d="M234.781 60.115c-1.484.969-1.122-1.105-1.967-1.193a.907.907 0 01-.232-.711 1.819 1.819 0 01.882-1.234 4.729 4.729 0 011.316 3.138"
              data-name="Path 2004"
              transform="translate(-85.418 -20.926)"
            ></path>
            <path
              fill="#df636e"
              d="M595.6 124.627a5.619 5.619 0 01-3.649 3.45 10.438 10.438 0 013.649-3.45"
              data-name="Path 2005"
              transform="translate(-217.402 -45.771)"
            ></path>
            <path
              fill="#95cead"
              d="M262.592 45.451l-.9-.919c.4-.8.467-1.8 1.6-2.416.631 1.375-.2 2.328-.694 3.335"
              data-name="Path 2006"
              transform="translate(-96.109 -15.468)"
            ></path>
            <path
              fill="#a9dcbe"
              d="M230.124 70.064a1.479 1.479 0 00-1.324.68l-1.883-1.912c1.393-1.3 1.979.94 3.126.712a3.523 3.523 0 00.081.521"
              data-name="Path 2007"
              transform="translate(-83.339 -25.129)"
            ></path>
            <path
              fill="#aedac4"
              d="M229.073 58.715q-.266-.047-.534-.076l-.64-1.275a1.126 1.126 0 011.307-1.256l.606.592a1.161 1.161 0 01.294 1.233 1.313 1.313 0 01-1.033.781"
              data-name="Path 2008"
              transform="translate(-83.699 -20.606)"
            ></path>
            <path
              fill="#c9d2d9"
              d="M409.079 33.258l-.608.626c-1.136-1.116-.425-2.541-.638-3.812a3.508 3.508 0 011.246 3.185"
              data-name="Path 2009"
              transform="translate(-149.772 -11.045)"
            ></path>
            <path
              fill="#cdf3db"
              d="M237.576 65.226a1.187 1.187 0 01-.578-1.3c1.34-.013 1.07-1.08 1.224-1.87.871.929.475 2.1.612 3.169a.836.836 0 01-1.259 0"
              data-name="Path 2010"
              transform="translate(-87.033 -22.791)"
            ></path>
            <path
              fill="#86d1a7"
              d="M260.985 54.257l1.79-1.067c.006 1.215-.861 2.056-1.315 3.074-.678-.546-.518-1.29-.475-2.006"
              data-name="Path 2011"
              transform="translate(-95.833 -19.535)"
            ></path>
            <path
              fill="#eefaf3"
              d="M264.49 64.679a1.215 1.215 0 00-.574-1.26c.383-.57.869-1.574 1.546-.8.831.943-.083 1.625-.973 2.064"
              data-name="Path 2012"
              transform="translate(-96.927 -22.894)"
            ></path>
            <path
              fill="#79dba4"
              d="M254.984 59.236l-.066-1.26 1.264-1.894c.063.689-.122 1.458.624 1.927a1.881 1.881 0 01-1.821 1.228"
              data-name="Path 2013"
              transform="translate(-93.622 -20.597)"
            ></path>
            <path
              fill="#fbeeed"
              d="M619.376 98.046l-.249 1.205-2.341 1.915c.2-1.589 1.365-2.381 2.59-3.121"
              data-name="Path 2014"
              transform="translate(-226.524 -36.009)"
            ></path>
            <path
              fill="#acf8cd"
              d="M237.679 78.121l1.338-.077c.818.123 1.577.3 1.279 1.424-.947.412-1.894 1.119-2.838-.008a1.092 1.092 0 01.278-.845q-.032-.247-.057-.495"
              data-name="Path 2015"
              transform="translate(-87.208 -28.663)"
            ></path>
            <path
              fill="#59c184"
              d="M233.061 56.511c-.1.532-.158 1.087-.726 1.371-1.037-.046-1-.584-.592-1.291-.016-.979.449-1.066 1.19-.641a.789.789 0 01.128.561"
              data-name="Path 2016"
              transform="translate(-85.013 -20.46)"
            ></path>
            <path
              fill="#9be7bb"
              d="M245.534 51.948q0 1.257-.009 2.513c-1.224-1.353-.44-2.978-.611-4.475.638.518.566 1.26.619 1.962"
              data-name="Path 2017"
              transform="translate(-89.914 -18.358)"
            ></path>
            <path
              fill="#55c382"
              d="M232.8 73.756a1.68 1.68 0 011.434-.8l1.073.845-1.286.572c-.494-.036-.98-.087-1.221-.621"
              data-name="Path 2018"
              transform="translate(-85.5 -26.796)"
            ></path>
            <path
              fill="#87d4a5"
              d="M236.409 78.913l.029.736c-.326.437-.6.97-1.306.7l-1.291-.568c.33-1.836 1.813-.283 2.568-.871"
              data-name="Path 2019"
              transform="translate(-85.881 -28.96)"
            ></path>
            <path
              fill="#c8e6d6"
              d="M226.279 44.964c-.494-.626-1.422-1.461-.535-2.042.783-.512.874.8 1.27 1.305a.862.862 0 01-.735.737"
              data-name="Path 2020"
              transform="translate(-82.772 -15.721)"
            ></path>
            <path
              fill="#e7bec6"
              d="M653.761 142.892a1.876 1.876 0 01.673-1.863 1.773 1.773 0 01.547 1.931l-1.221-.068"
              data-name="Path 2021"
              transform="translate(-240.092 -51.795)"
            ></path>
            <path
              fill="#98d5af"
              d="M228.969 48.03l-.727.755-.582-.708c-.067-.711-.971-1.693.606-1.87a2.678 2.678 0 01.7 1.822"
              data-name="Path 2022"
              transform="translate(-83.495 -16.971)"
            ></path>
            <path
              fill="#040614"
              d="M674.942 47.075v.6a3.624 3.624 0 01-3.162-.016c.5-.735 1.367-.406 2.023-.693l1.14.113"
              data-name="Path 2023"
              transform="translate(-246.721 -17.247)"
            ></path>
            <path
              fill="#b8e1ca"
              d="M228.069 45.784c-.724.454-.493 1.217-.606 1.87-.619-.481-.586-1.191-.658-1.865l.735-.736.53.731"
              data-name="Path 2024"
              transform="translate(-83.297 -16.546)"
            ></path>
            <path
              fill="#b7bfcc"
              d="M104.556 16.91v4.453c-.419 1.838-1.756 1.106-2.937 1.177-1.517.091-3.989-.606-4.036 1.662-.04 1.958 2.4 1.757 3.807 1.7 2.437-.094 3.159.848 2.912 3.126a4.653 4.653 0 00.256 3.052v5.717c-1.4 1.844-2.272.788-2.988-.59a9.118 9.118 0 01-.478-2.463c-.292-1.435-1.346-1.744-2.592-1.76-.7-.01-1.265.213-1.293 1.023a2.1 2.1 0 001.641 2.357 3.117 3.117 0 012.637 2.754c.239 2.055-.139 3.773-2.416 4.51-1.022.33-2.086.785-1.82 2.149.228 1.173 1.342 1.087 2.237 1.358 1.542.467 3.579-1.379 4.6.59.683 1.322.1 3.1.212 4.669a.953.953 0 00.263.554v5.089c-1.3 1.819-2.1 1.865-2.986.17-.1-.185-.137-.4-.22-.59-.527-1.227.105-3.46-2.07-3.3-2.385.172-1.655 2.511-2.088 4-.979 3.356.239 6.695.115 10.042-.543 14.717.166 29.432.053 44.15-.153 19.891-.07 39.783-.005 59.675.011 3.162-.385 6.289-.395 9.451-.008 2.822 1.169 3.453 3.646 3.084 1.4-.209 2.989-.662 3.945 1.033v1.287a2.617 2.617 0 01-1.517.295c-17.953-.03-35.905.065-53.856-.049-.748-1.672.614-1.922 1.624-2.24a12.491 12.491 0 013.771-.261c10.329-.008 20.659-.065 30.988.039 2.635.027 4.847.04 4.558-3.509-.025-.306.276-.556.454-.818 2.9-.853 3.58-2.844 3.571-5.737q-.136-42.5.009-85c.011-2.947-.756-4.828-3.638-5.636-.858-3.138-3.115-3.631-6.034-3.615-17.159.09-34.317.05-51.476.039a13.9 13.9 0 01-4.386-.359c-.482-.158-1.076-.342-1.1-.928-.027-.609.54-.849 1.048-1a13.341 13.341 0 013.761-.26q28.423-.013 56.845-.016c1.348 0 2.753.261 3.981-.561.211-.229.547-.432.589-.719a70.142 70.142 0 00.112-15.942c-.056-.668-.685-1.022-1.167-1.422-2.47-1.874-5.259-2.348-8.317-2.316-9.9.1-19.8.043-29.7.034-1.579 0-3.292.249-4.661-.549-3.052-1.779-6.035-1.123-8.718.37a20.4 20.4 0 01-8.39 2.313c-1.418.425-3.119.03-4.182 1.468-.577 1.956-1.183 3.848-3.639 4.209a1.348 1.348 0 00-1.272 1.53c.085.925.813 1.19 1.534 1.341 2.1.439 2.973 1.707 2.936 3.824-.032 1.855-.437 3.367-2.5 3.815-1.927.418-2.443 1.758-2.437 3.511 0 1.158-.015 2.317-.015 3.475q0 47.867-.005 95.734a16.933 16.933 0 01-.27 4.4c-.188.709-.421 1.47-1.355 1.495-.745.02-1.063-.575-1.375-1.128a3.854 3.854 0 01-.65-2.408c.634-3.965-.385-7.948.192-11.9.324-2.22-.4-4.368-.323-6.585.314-9.568.165-19.146.313-28.717.173-11.21-.352-22.45-.256-33.678.061-7.212-.159-14.447.164-21.622.24-5.324.127-10.679.129-15.961 0-4.968.025-10.029.008-15.008-.017-5.193-.82-10.448.137-15.646.369-2.005-.158-3.962-.322-5.946-.549-6.625.9-13.206.616-19.844-.071-1.645.945-2.5 2.708-2.117.513.112 1.111.4 1.548.2 5.818-2.7 11.422 1.207 17.3.463 5.91-.749 11.989-.153 17.994-.168s12.037-.2 17.991.277c6.974.559 13.884-1.043 20.806-.063 2.479.351 2.406-2.38 4.008-3.024h1.267c.676 3.116.125 6.272.3 9.4.084 1.474-.745 1.817-2 1.642a8.685 8.685 0 00-3.457.039c-.874.23-1.591.678-1.616 1.682-.028 1.086.776 1.391 1.661 1.539a8.222 8.222 0 003.454-.015c1.347-.351 1.941.347 2.258 1.5"
              data-name="Path 2025"
              transform="translate(-7.177 -.412)"
            ></path>
            <path
              fill="#b8becc"
              d="M90.445 180.675c.013 1.65-.215 3.331 1.073 5.078-13.253 0-26.086-.011-38.918.016-1.4 0-3.04-.519-3.907 1.247-3.955.7-7.942.221-11.913.281a585.13 585.13 0 01-16.706-.006 1.182 1.182 0 01-.921-.74 14.236 14.236 0 01-.183-3.458q-.009-88.85.011-177.7c0-1.439-.365-2.967.619-4.279h82.855a15.97 15.97 0 00-.621 2.411c-.172 1.665-1.083 2.153-2.6 1.884a37.992 37.992 0 00-13.761.078c-3.625.68-7.256-.349-10.9-.356-3.474-.007-7.04.309-10.578-.146-3.111-.4-6.313-.084-9.475-.084h-7.906c-2.635 0-5.272.056-7.9-.016s-6.528 1.187-7.619-.4c-2.911-4.225-4.182 1.622-6.24.422-.159-.092-.457.058-.619-.032-4.2-2.317-3.411.88-3.35 3.085.12 4.314-.774 8.646-.5 12.87.413 6.253.225 12.526.193 18.73-.025 4.827.157 9.752-.049 14.623-.213 5-.788 10.189.247 15.233.507 2.471-.774 4.785-.517 7.183a91.68 91.68 0 01.345 14.6c-.488 8.949-.23 17.872-.328 26.8-.161 14.535-.046 29.074-.042 43.611 0 5.9.7 11.791.013 17.691a6.088 6.088 0 001.134 4.31c1.276-.993.718-2.342.719-3.448q.055-50.42 0-100.84c0-2.751-.057-4.963 3.748-5 2.285-.024 1.093-2.282 1.31-3.553.254-1.488-.571-2.142-2.03-2-2.418.236-3.243-.959-2.976-3.216.13-1.107.72-1.911 1.8-1.786 2.718.316 3.585-.911 3.305-3.424-.037-.332.357-.712.551-1.07 1.122 1.076.986 2.5 1.01 3.85.065 3.476-.025 6.954.04 10.431.061 3.26.383 3.622 3.675 3.649 8.432.068 16.864.021 25.3.024 10.54 0 21.081-.019 31.621.02 1.646.006 3.415-.318 4.789 1.039-1.069 1.027-2.4.569-3.614.571q-29.682.045-59.365.021h-4.021a6.4 6.4 0 003.939.615q27.472.037 54.945.018c4.289 0 4.289.006 4.313 4.411-1.495 1.387-3.369 1.012-5.116 1.015-17.169.034-34.339.013-51.509.023-4.911 0-4.969.058-4.97 4.884q-.011 42.333 0 84.664c0 .737.028 1.474.038 2.21.026 1.96.857 2.746 2.944 2.659 18.213-.761 36.436-.189 54.655-.306 1.448-.009 3.241-.41 3.965 1.591"
              data-name="Path 2026"
              transform="translate(-6.947 -.41)"
            ></path>
            <path
              fill="#b8becc"
              d="M148.761 215.833c-2.149-1.214-4.263.464-6.451.066-1.627-.3-2.943.542-2.163-2.587.6-2.425.423-5.492.423-8.276 0-28.846.111-57.693-.076-86.537-.046-6.965.312-13.936-.027-20.878a75.321 75.321 0 01.273-12.45c.244-2.107 1.228-2.079 2.644-2.117 1.481-.04 2.809.121 2.862 2.056a17.485 17.485 0 00.07 2.521c.375 2.12 1.357 1.684 2.449.494q0 63.854-.006 127.707"
              data-name="Path 2027"
              transform="translate(-51.386 -30.501)"
            ></path>
            <path
              fill="#b1b8c6"
              d="M19.2 187.635c-1.974-.385-1.219-1.974-1.223-3.065-.049-13.908-.032-27.815-.032-41.722q0-68.9.026-137.809c0-1.306-.532-2.754.588-3.916.618 1.2.3 2.484.3 3.724q.028 89.225.033 178.451c0 1.238-.325 2.527.309 3.72v.005q.312.2.208.408c-.069.135-.138.2-.208.2"
              data-name="Path 2028"
              transform="translate(-6.552 -.412)"
            ></path>
            <path
              fill="#b9c2d4"
              d="M19.568 187.016c-1.142-1.152-.607-2.6-.607-3.908q-.048-90.995-.035-181.988h.645v185.9"
              data-name="Path 2029"
              transform="translate(-6.918 -.41)"
            ></path>
            <path
              fill="#b8becc"
              d="M148.934 70.909c.053-4.4-2.04-6.033-6.35-5.076-1.782.4-2.174-1.191-2.2-2.368a2.333 2.333 0 012.473-2.644c2.07.016 2.324-1.269 2.34-2.931.016-1.77-.521-2.83-2.5-2.784-2.971.07-1.6-2.3-2.005-3.667-.488-1.659.765-1.429 1.628-1.353 1.526.133 3.608-.8 4.061 1.745.164.921-.011 1.9.1 2.831.2 1.635 1.14 1.831 2.45 1.1v15.147"
              data-name="Path 2030"
              transform="translate(-51.556 -18.372)"
            ></path>
            <path
              fill="#b3bac5"
              d="M19.992 295.537v-.612h29.1l55.63.012c-.821.986-1.953.6-2.955.6q-40.886.021-81.772 0"
              data-name="Path 2031"
              transform="translate(-7.342 -108.314)"
            ></path>
            <path
              fill="#b8becc"
              d="M148.926 16.911c-1.63-2.139-3.633.186-5.6-.43-1.721-.54-3.026-.866-2.973-2.7s1.326-2.418 3.183-2.659c1.6-.207 3.708 1.029 4.355.165 1.144-1.527.324-3.816.416-5.783.069-1.458.014-2.923.014-4.384 1.333 2.563.425 5.3.587 7.955.159 2.6.022 5.221.015 7.833"
              data-name="Path 2032"
              transform="translate(-51.547 -.413)"
            ></path>
            <path
              fill="#b8becc"
              d="M149.122 43.831c-.134-.157-.406-.341-.38-.466.933-4.675-2.166-5.144-5.5-5.163-1.76-.01-2.364-.64-2.348-2.39.016-1.709 1.026-1.672 2.245-2.21 2.054-.907 4.126.859 5.985-.49v10.719"
              data-name="Path 2033"
              transform="translate(-51.744 -12.161)"
            ></path>
            <path
              fill="#1f293c"
              d="M593.547 185.113c-.708 2.284-1.562 4.535-2.066 6.863-.278 1.286 1.085.327 1.562.707-.752 2.081-2.653 1.731-4.254 2.022a18.233 18.233 0 01-2.919-.165 7.185 7.185 0 01-.909-.2c-2.87.317-4.344-2.676-7.019-2.975-.61-.068-.264-1.071.074-1.624.707-.893 1.706-.491 2.593-.588 1.173-.242 2.451-.132 3.433-1.021l-.029.027c1.222-.6 2.842.139 3.865-1.14l1.889-.864a3.923 3.923 0 012.405-.819l1.377-.226"
              data-name="Path 2034"
              transform="translate(-212.134 -67.985)"
            ></path>
            <path
              fill="#307dd7"
              d="M589.915 181.132c-4.057-.575-6.749-3.153-9.122-6.2.2-.323.429-.335.692-.079 2.324 2.744 5.8 3.947 8.429 6.281"
              data-name="Path 2035"
              transform="translate(-213.305 -64.151)"
            ></path>
            <path
              fill="#597ac3"
              d="M579.631 170.55l-.692.078c-1.7-2.286-3.586-4.5-3.123-7.666l3.815 7.588"
              data-name="Path 2036"
              transform="translate(-211.451 -59.85)"
            ></path>
            <path
              fill="#3671c0"
              d="M599.228 185.257c-.776.349-1.451.995-2.406.819l.017-1.185 2.389.366"
              data-name="Path 2037"
              transform="translate(-219.192 -67.904)"
            ></path>
            <path
              fill="#151020"
              d="M662.849 92.352c.1-.478.216-1.186.837-.8s.322 1.044-.164 1.51l-.673-.712"
              data-name="Path 2038"
              transform="translate(-243.441 -33.583)"
            ></path>
            <path
              fill="#fefefe"
              d="M494.694 265.763c-3.634 2.195-7.438 1.368-11.237.635l-.365-3.173a9.442 9.442 0 01-.475-2.488 9.969 9.969 0 01.8-3.486c.937-1.931.1-4.513 2.2-6.019 3.619-7.06 5.838-14.707 9.178-21.883.868-1.865 1.346-3.974 3.183-5.255.313-1.273 1.593-1.389 2.428-2.043 3.533-1.88 7.39-2.961 11.068-4.487a2.351 2.351 0 012.407.075c.7 1.323-.08 2.458-.534 3.586-5.523 13.721-10.937 27.485-16.478 41.2-.5 1.242-.821 2.636-2.174 3.338"
              data-name="Path 2039"
              transform="translate(-177.248 -79.795)"
            ></path>
            <path
              fill="#2267bd"
              d="M523 210.341a96.277 96.277 0 00-13.217 5.029c-1.159.316-2.371.713-2.005-1.307 1.541-5.34 4.521-10.015 6.92-14.958.519-1.071 1.587-.759 2.5-.867 2.13-.254 4.367.652 6.4-.585 1.2-1.072 2.5-.59 3.76-.188a33.555 33.555 0 005.34 1.353c4.137 1.122 8.448.794 12.632 1.506 1.119 2.02-.807 2.24-1.8 2.661-3.958 1.686-7.923 3.366-11.99 4.779-2.955.5-5.4 2.7-8.544 2.577"
              data-name="Path 2040"
              transform="translate(-186.466 -72.351)"
            ></path>
            <path
              fill="#daa76e"
              d="M479.078 259.034a2.792 2.792 0 01-.323 2.306c-2.851-2-4.045-4.2-2.022-7.734a5.318 5.318 0 00-.841-4.895c.128-7.232-1.891-14.262-2.1-21.474-.02-.683.483-3.251-2.2-2.13-.692.289-1.024-1.273-.611-1.691 2.787-2.818 1.248-6.07 1.117-9.185a2.572 2.572 0 01.429-2.09c.588 3.561.475 7.225 1.6 10.7.424 1.05-.128 2.231.438 3.262l.113 1.716c1.251 2.668.474 5.616 1.153 8.362-.171 4 .9 7.854 1.389 11.775.805.991.787 2.266 1.182 3.4.523 2.532.175 5.14.671 7.676"
              data-name="Path 2041"
              transform="translate(-172.91 -77.911)"
            ></path>
            <path
              fill="#222d40"
              d="M572.554 191.6c-.873.092-1.863-.286-2.528.634-.571.516-1.774.5-1.584 1.644.166.994 1.048 1.189 1.905 1.3a8.729 8.729 0 011.543.212c.566.178 1.349.247 1.219 1.1-.087.564-.694.714-1.2.833-1.119.263-2.285.116-3.407.371a4.2 4.2 0 01-.878.032c-1.4-.193-2.8-.59-4.13.275a2.7 2.7 0 01-.831.23c-1.346-.063-2.74.283-4.027-.216-1.026-.4-3.335-.252-1.417-2.427.164-.186.339-.339.208-.461-.32-.3-.773-.218-1.164-.325-.6-.163-1.4-.289-1.374-1.012.03-.867.907-1.018 1.617-1.213 1.966-.159 3.957.29 5.9-.275l10.143-1.352q.326.217.22.437t-.215.22"
              data-name="Path 2042"
              transform="translate(-203.791 -70.127)"
            ></path>
            <path
              fill="#2c3444"
              d="M539.221 196.887c-3.123.187-5.743-2.033-8.865-1.851a1.021 1.021 0 01-.051-.438c-.854-.967-2.239-.97-3.19-1.753-1.253-1.033-1.472-2.041.118-2.969a45.538 45.538 0 0013.383 2.3c1.243 1.177 2.022 2.913 4 3.231.344.056.573.566.452 1.032-.129.5-.5.559-.943.542a47.025 47.025 0 00-4.907-.093"
              data-name="Path 2043"
              transform="translate(-193.221 -69.734)"
            ></path>
            <path
              fill="#2680d7"
              d="M483.844 212.406a9.534 9.534 0 011.265-4.427c1.839.638 3.328 2.359 5.69 1.379.953-.4 1.25.778 1.257 1.684.007 1.013-.106 2-1.423 1.951-2.27-.082-4.609.549-6.789-.587"
              data-name="Path 2044"
              transform="translate(-177.699 -76.383)"
            ></path>
            <path
              fill="#2e3a4c"
              d="M541.77 192.491c-4.364.539-8.47-1.4-12.787-1.335-.781.011-1.039-.583-1.088-1.278a99.127 99.127 0 0024.6 2.027c-2.008 1.167-4.21.3-6.3.607-1.476.587-2.952 1.053-4.421-.022"
              data-name="Path 2045"
              transform="translate(-193.877 -69.735)"
            ></path>
            <path
              fill="#232f46"
              d="M481.337 272.265a7.143 7.143 0 01-.417-3.513c1.4.306 2.987.1 4.054 1.388a29.016 29.016 0 01-1.505 6.507c-1.522-.88-1.179-2.543-1.676-3.857-.03-.08.756-1.392-.456-.525"
              data-name="Path 2046"
              transform="translate(-176.605 -98.703)"
            ></path>
            <path
              fill="#246dbe"
              d="M478.077 242.365a29.874 29.874 0 01-1.154-8.365c1.448-1.374-.52-4 1.842-5.037-.859 4.434-.554 8.928-.689 13.4"
              data-name="Path 2047"
              transform="translate(-175.152 -84.091)"
            ></path>
            <path
              fill="#2e3a4c"
              d="M527.1 189.689c-1.186 1.284-.728 2.177.633 2.95.871.495 2.042.611 2.438 1.77-2.094-.781-4.964-.793-4.353-4.29.138-.789.614-1 1.281-.431"
              data-name="Path 2048"
              transform="translate(-193.082 -69.548)"
            ></path>
            <path
              fill="#1b80e2"
              d="M480.029 247.425v-5.287h.318v5.548l-.318-.264"
              data-name="Path 2049"
              transform="translate(-176.298 -88.929)"
            ></path>
            <path
              fill="#1f2a3c"
              d="M591.595 188.13c-.47 1.209-.47 1.209-3.865 1.14 1.138-.888 2.543-.873 3.865-1.14"
              data-name="Path 2050"
              transform="translate(-215.852 -69.093)"
            ></path>
            <path
              fill="#296ec0"
              d="M507.195 223.967c.076 1.344 1.1 1.234 2 1.307l-2.59 1.279c-1.134-1.164-.051-1.824.586-2.587"
              data-name="Path 2051"
              transform="translate(-185.878 -82.255)"
            ></path>
            <path
              fill="#1f2a3c"
              d="M582.8 191.205v-.657a5.318 5.318 0 013.148-.668c-.572 1.57-1.918 1.306-3.144 1.326"
              data-name="Path 2052"
              transform="translate(-214.042 -69.73)"
            ></path>
            <path
              fill="#1480db"
              d="M571.864 150.235a.772.772 0 01.528-.012c-.046 1.432.286 2.887-.275 4.5-.564-1.612-.252-3.059-.252-4.489"
              data-name="Path 2053"
              transform="translate(-209.994 -55.157)"
            ></path>
            <path
              fill="#1e7fe0"
              d="M558.036 153.2h3.551c0 .106.006.211.008.316h-3.608l.049-.316"
              data-name="Path 2054"
              transform="translate(-204.929 -56.264)"
            ></path>
            <path
              fill="#1680e2"
              d="M482.075 261.132a4.073 4.073 0 01.172 3.126c-.789-1.114-.163-2.161-.172-3.126"
              data-name="Path 2055"
              transform="translate(-176.965 -95.904)"
            ></path>
            <path
              fill="#1b80e2"
              d="M547.843 155.332a4.827 4.827 0 01-3.836 0z"
              data-name="Path 2056"
              transform="translate(-199.794 -57.048)"
            ></path>
            <path
              fill="#1f7ee4"
              d="M527.751 159.289a2.889 2.889 0 01-2.354.174 2.136 2.136 0 012.354-.174"
              data-name="Path 2057"
              transform="translate(-192.96 -58.402)"
            ></path>
            <path
              fill="#1c82e5"
              d="M536.556 157.21c-.573.689-1.211.353-2.03.407.709-.935 1.386-.345 2.03-.407"
              data-name="Path 2058"
              transform="translate(-196.312 -57.691)"
            ></path>
            <path
              fill="#a6afbb"
              d="M391.141 71.392v.665c-.039 2.076.307 4.844-2.333 5.109-2.911.292-3.473-2.7-3.873-4.863a11.362 11.362 0 01.44-6.514c.9-2.149 2.59-2.44 4.018-.569a8.23 8.23 0 011.749 6.171"
              data-name="Path 2059"
              transform="translate(-141.273 -23.498)"
            ></path>
            <path
              fill="#a7afbd"
              d="M462.984 104.865v1.263a3.416 3.416 0 01-2.385.623c-11.678.006-23.356.03-35.035-.012a3.677 3.677 0 01-1.537-.294.76.76 0 01-.312-1.051c.635-.936 1.61-.835 2.551-.835h35.522a2.158 2.158 0 011.194.306"
              data-name="Path 2060"
              transform="translate(-155.581 -38.4)"
            ></path>
            <path
              fill="#bbbcbf"
              d="M423.5 105.285c0 .219-.007.438-.011.657 1.083.608 2.262.3 3.392.3 10.907.027 21.815.008 32.723.029 1.029 0 2.1-.257 3.088.28.011.2.012.408.005.611l-39.774-.017c.033-1.067-.486-2.23.552-3.119a.857.857 0 01.025 1.254"
              data-name="Path 2061"
              transform="translate(-155.286 -38.207)"
            ></path>
            <path
              fill="#a2a7b3"
              d="M423.875 105.24l-.025-1.254q18.313-.018 36.626-.022c.895 0 1.932-.342 2.592.663h-35.217c-1.357 0-2.736-.144-3.976.614"
              data-name="Path 2062"
              transform="translate(-155.665 -38.162)"
            ></path>
            <path
              fill="#a3a8b4"
              d="M463.074 107.661q-18.125.006-36.25 0c-1 0-2.13.36-2.953-.612l39.206-.006a2.061 2.061 0 010 .621"
              data-name="Path 2063"
              transform="translate(-155.673 -39.312)"
            ></path>
            <path
              fill="#f5ba76"
              d="M229.928 111.052l46.807.007c.444 2.531-1.537 1.178-2.229 1.184-10.8.095-21.593.066-32.39.066-3.25 0-6.5.015-9.749-.009-1-.007-2.212.308-2.439-1.248"
              data-name="Path 2064"
              transform="translate(-84.444 -40.785)"
            ></path>
            <path
              fill="#fefefe"
              d="M337.524 231.975c-1.154.9-2.512.294-3.758.51q-55.071-.016-110.142-.073c-1.278 0-3.073.919-3.745-1.216l.023.008c.834-1.816.85-3.808 1.233-5.722q2.066-10.1 4.126-20.2c.166-.814.255-1.643.379-2.466.649-4.062 1.675-8.046 2.521-12.067q3.751-17.715 7.5-35.431c2.032-9.661 4.085-19.317 6-29 .449-2.266 1.429-3.14 3.777-3.138q58.428.075 116.857.047c1.657 0 3.432-.034 4.306 1.875.688 7.755 2.291 15.372 3.458 23.054q2.7 17.761 5.419 35.518c-.012.148-.025.3-.035.444-3.786 4.5-8.415 8.129-12.653 12.162-6.38 6.071-12.836 12.059-18.523 18.809a55.858 55.858 0 01-6.818 5.753 3.044 3.044 0 01-1.346.073c-3.866-1.131-7.838-.918-11.791-.88-.47 0-1.328-.439-1.338.642a16.175 16.175 0 002.794 1.948c3.259 2.4 6.562 4.731 9.989 6.89.794.673 1.688 1.276 1.765 2.461"
              data-name="Path 2065"
              transform="translate(-80.754 -45.239)"
            ></path>
            <path
              fill="#fefefe"
              d="M433.677 277.994c-.928.386-1.588 1.185-2.8 1.17-6.8-.086-13.6-.046-20.407-.049a1.791 1.791 0 01-1.663-.662c-.154-2.02 1.748-2.417 2.794-3.458 2.3-2.289 4.87-4.278 7.355-6.363 5.579-1.917 9.616-6.257 14.5-9.277 4.542-2.811 8.729-6.176 13.266-9.019a1.593 1.593 0 011.353.111c1 2.763.932 5.719 1.551 8.551a8.231 8.231 0 01-.111 2.68 15.518 15.518 0 01-.211 1.834c-.068 6.446-5.137 8.482-9.678 10.987-1.985 1.159-3.257 3.541-5.95 3.5"
              data-name="Path 2066"
              transform="translate(-150.138 -91.903)"
            ></path>
            <path
              fill="#daa76e"
              d="M465.7 218.736c1.25-.359 1.163.41 1.34 1.317.661 3.383.518 6.914 1.846 10.173l.015.017-.059 4.508a.776.776 0 01-.928-.317c-1.257-5.116-2.651-10.212-2.335-15.565z"
              data-name="Path 2067"
              transform="translate(-170.974 -80.301)"
            ></path>
            <path
              fill="#daa76e"
              d="M478 291.052l-3.129.1-4.9-.2q-.277-.22-.2-.458c.053-.161.108-.242.163-.242 1.124-.927 2.773-.044 3.849-1.12.182-1.272-.438-2.47-.323-3.732a4.219 4.219 0 01.474-2.252c.121-.1.243-.2.366-.307 1.078 1.419.851 3.238 1 4.775a3.492 3.492 0 002.7 3.434"
              data-name="Path 2068"
              transform="translate(-172.524 -103.878)"
            ></path>
            <path
              fill="#daa76e"
              d="M474.293 268.933a25.278 25.278 0 011.236 8.8l-.111.1c-1.536.631-1.359-.487-1.414-1.374a6.313 6.313 0 00-.25-2.865c-.2-.521-.432-1.033-.585-1.574a2.921 2.921 0 01.012-1.286 2.72 2.72 0 011.111-1.8"
              data-name="Path 2069"
              transform="translate(-173.754 -98.77)"
            ></path>
            <path
              fill="#a99584"
              d="M473.89 267.152c-.1.65.1 1.374-.463 1.912-.509-.008-.652-.387-.791-.771-.135-.593.005-1.28-.576-1.729a3.149 3.149 0 01.777-2.482c1.156.747.893 1.98 1.052 3.069"
              data-name="Path 2070"
              transform="translate(-173.352 -96.988)"
            ></path>
            <path
              fill="#daa76e"
              d="M478.16 269.939v3.1c-.358-1.048-2.468-2.175 0-3.1"
              data-name="Path 2071"
              transform="translate(-175.177 -99.138)"
            ></path>
            <path
              fill="#416da3"
              d="M469.337 243.854a3.792 3.792 0 01.538.155.659.659 0 00.059.546 5.07 5.07 0 01.19 3.057.64.64 0 00-.182.492l-1.195.426a1.025 1.025 0 01-.4-.7 4.488 4.488 0 01.073-.839c.292-1.048-.1-2.3.917-3.136"
              data-name="Path 2072"
              transform="translate(-172.007 -89.559)"
            ></path>
            <path
              fill="#daa76e"
              d="M473.284 255.729c1.2 1.148 1.087 2.227.632 3.852l-.632-3.852"
              data-name="Path 2073"
              transform="translate(-173.82 -93.92)"
            ></path>
            <path
              fill="#daa76e"
              d="M470.832 236.158c.179-.474-.374-1.3.576-1.36.2-.012.6.561.614.88.063 1.1-.649.633-1.176.5l-.015-.017"
              data-name="Path 2074"
              transform="translate(-172.92 -86.233)"
            ></path>
            <path
              fill="#daa76e"
              d="M471.046 248.019l-.19-3.057a2.274 2.274 0 01.19 3.057"
              data-name="Path 2075"
              transform="translate(-172.929 -89.966)"
            ></path>
            <path
              fill="#daa76e"
              d="M480.828 291.306c-.211.333-.349.785-.538.807-.69.081-.387-.518-.425-.837-.035-.292.049-.693.459-.592.2.05.335.4.5.622"
              data-name="Path 2076"
              transform="translate(-176.225 -106.752)"
            ></path>
            <path
              fill="#daa76e"
              d="M475.929 262.217c.093-.386.18-.737.563-.5a1.028 1.028 0 01.413.688c.033.32-.23.583-.559.409-.208-.11-.306-.428-.417-.6"
              data-name="Path 2077"
              transform="translate(-174.792 -96.091)"
            ></path>
            <path
              fill="#fefefe"
              d="M530.862 207.214c4.619-2.5 9.86-3.576 14.375-6.307 2.428-2.022 5.488-.43 8.121-1.407.744-.276 1.677.027 2.442-.432 2.165-.885 4.554.028 6.725-.831a10.53 10.53 0 004.426-1.253l.722-.146c1.967-.177 2.363 1.4 2.964 2.7q9.656 20.83 19.289 41.67 3.958 8.558 7.906 17.121c-.6 2.007-2.272 1.139-3.454 1.141q-41.615.075-83.23.041c-1.26 0-2.521.028-3.782.043l-.665-.677c-.458-1.258.316-2.232.791-3.252 5.185-11.142 10.745-22.113 15.624-33.389 1.8-4.149 4.136-8 5.887-12.147a5.944 5.944 0 011.86-2.871"
              data-name="Path 2078"
              transform="translate(-186.042 -72.287)"
            ></path>
            <path
              fill="#1f293c"
              d="M604.8 194.484c-.779-.216-1.692.149-2.373-.538 1.579-.9 1.579-.9 2.765.487l-.186.1z"
              data-name="Path 2079"
              transform="translate(-221.251 -71.001)"
            ></path>
            <path
              fill="#dea765"
              d="M651.7 292.365c.214-.925-.346-2.1 1.039-2.839.312 1.287.763 2.427-1.047 2.835h.008"
              data-name="Path 2080"
              transform="translate(-239.345 -106.333)"
            ></path>
            <path
              fill="#ddba94"
              d="M231.448 229.966a52.051 52.051 0 01-2.521 12.067c-.565-3.3 1.5-6.257 1.239-9.516.973-.576.217-2.021 1.283-2.551"
              data-name="Path 2081"
              transform="translate(-84.041 -84.458)"
            ></path>
            <path
              fill="#dda86e"
              d="M239.5 184.9c-.589-1.285-2.339-2-1.786-3.629.174-.512 1.167-.384 1.7-.031 1.762 1.158-.345 2.4.083 3.66"
              data-name="Path 2082"
              transform="translate(-87.264 -66.45)"
            ></path>
            <path
              fill="#dda86e"
              d="M231.85 175.89c.756-.375.629-1.2 1.181-1.867a12.707 12.707 0 01.129 1.864c-.069.98 1.325 2.664-.458 2.77-1.417.083-.515-1.838-.84-2.813l-.012.046"
              data-name="Path 2083"
              transform="translate(-85.15 -63.912)"
            ></path>
            <path
              fill="#dda86e"
              d="M241.833 176.584c-.685-.612-1.8-1.005-1.286-2.159.064-.143.614-.227.828-.12 1.024.517.4 1.462.458 2.278"
              data-name="Path 2084"
              transform="translate(-88.296 -63.998)"
            ></path>
            <path
              fill="#dda86e"
              d="M245.722 152.517c.866.878.4 1.625.415 2.691-1.408-1.018-1.21-1.756-.415-2.691"
              data-name="Path 2085"
              transform="translate(-90.017 -56.014)"
            ></path>
            <path
              fill="#dda86e"
              d="M231.189 222.094c1.465.534.873 1.272 1.177 2.039-1.057-.583-.671-1.271-1.177-2.039"
              data-name="Path 2086"
              transform="translate(-84.908 -81.567)"
            ></path>
            <path
              fill="#2a2129"
              d="M664.037 72.051a1.692 1.692 0 002.044 1.291c.894-.127 1.686.1 1.765 1.24-1.148-.68-2.446-.341-3.656-.55-2.307-.4-1.313-1.221-.154-1.981"
              data-name="Path 2087"
              transform="translate(-243.421 -26.462)"
            ></path>
            <path
              fill="#241c2b"
              d="M667.3 80.952c-.786.962-1.559 1.218-2.3-.042l2.3.042"
              data-name="Path 2088"
              transform="translate(-244.23 -29.715)"
            ></path>
            <path
              fill="#f6e6cf"
              d="M221.149 284.863c.12 2.022.176 4.029-1.233 5.721a14.387 14.387 0 011.233-5.721"
              data-name="Path 2089"
              transform="translate(-80.767 -104.62)"
            ></path>
            <path
              fill="#aeddce"
              d="M235.882 80.149l1.306-.7c.847.569 1.68-.325 2.524-.023a.927.927 0 01.731-.309c1.309.355 2.372-.4 3.521-.787a2.446 2.446 0 01.866.032 1.116 1.116 0 01.631.568c-.707 1.828-2.229 1.958-3.838 1.763-1.91-.232-3.921.612-5.741-.539"
              data-name="Path 2090"
              transform="translate(-86.631 -28.757)"
            ></path>
            <path
              fill="#7ae3a7"
              d="M250.514 77.671l-.71-.121c-.382-.609-.011-1.093.261-1.6.46-.471.669-1.381 1.649-.96.563.1 1.532-.2 1.531.565 0 1.22-1.682.978-2.143 1.933q-.3.077-.588.178"
              data-name="Path 2091"
              transform="translate(-91.684 -27.503)"
            ></path>
            <path
              fill="#f4b979"
              d="M460.416 116.829c-1.579.76-2.706.591-4.411.341 1.644-.542 2.654-1.527 4.411-.341"
              data-name="Path 2092"
              transform="translate(-167.474 -42.702)"
            ></path>
            <path
              fill="#f4f6f6"
              d="M329.495 92.2c4.011.073 2.549 2.861 2.465 4.965-.669.928-1.339 2.242-2.662 1.615-1.133-.537-.464-1.9-.4-2.869a35.1 35.1 0 01.6-3.712"
              data-name="Path 2093"
              transform="translate(-120.699 -33.861)"
            ></path>
            <path
              fill="#191c27"
              d="M692.487 69.535c-.883-.78-.921-1.673-.291-2.9.114 1.135.2 2.02.291 2.9"
              data-name="Path 2094"
              transform="translate(-254.062 -24.471)"
            ></path>
            <path
              fill="#232e40"
              d="M671.78 48.057l3.162.016a2.112 2.112 0 01-3.162-.016"
              data-name="Path 2095"
              transform="translate(-246.721 -17.65)"
            ></path>
            <path
              fill="#161a28"
              d="M663.588 44.789c.954.795.8 1.743.261 2.741l-.276-2.713.015-.028"
              data-name="Path 2096"
              transform="translate(-243.707 -16.449)"
            ></path>
            <path
              fill="#1868c2"
              d="M475.525 212.869a3.593 3.593 0 01.375 3.837l-.375-3.837"
              data-name="Path 2097"
              transform="translate(-174.643 -78.179)"
            ></path>
            <path
              fill="#246dbe"
              d="M476.428 232.319a4.371 4.371 0 01-.439-3.262c.867.991.38 2.163.439 3.262"
              data-name="Path 2098"
              transform="translate(-174.77 -84.124)"
            ></path>
            <path
              fill="#78e1a7"
              d="M248.9 56.072l.589-.015c1.273 1.467.193 3.348.869 4.92a1.284 1.284 0 01-.245 1.417l-.635.011c-.478.976-.258 2.155-.891 3.089a1.34 1.34 0 01-1.013.656c-1.254-1.412.042-2.741.282-4.022.313-1.677.577-3.222-.259-4.782.208-.633.9-.79 1.257-1.279z"
              data-name="Path 2099"
              transform="translate(-90.726 -20.588)"
            ></path>
            <path
              fill="#5fcd8e"
              d="M246.68 77.191c-1.174.585-2.171 2.291-3.708.589-.335-.733.644-1.324.217-2.07a1.135 1.135 0 01.379-1.036c1.1.871 1.559-.847 2.5-.619a1.412 1.412 0 011.076.878 2.3 2.3 0 01-.463 2.258"
              data-name="Path 2100"
              transform="translate(-89.209 -27.19)"
            ></path>
            <path
              fill="#6be09f"
              d="M242.486 59.241c1.007.111 1.29-.881 1.958-1.284q.374-.378.651.077c-1.4 1.655-1.527 3.75-1.865 5.836-.936-1.526-2.046-2.908-.745-4.628"
              data-name="Path 2101"
              transform="translate(-88.838 -21.222)"
            ></path>
            <path
              fill="#abe9c4"
              d="M242.507 74.63l-.08 1.262a1.544 1.544 0 01-2.416-.111l.121-.668.438-.45.687-.6c.723-.446.877.249 1.2.6z"
              data-name="Path 2102"
              transform="translate(-88.148 -27.146)"
            ></path>
            <path
              fill="#52cc85"
              d="M248.577 73.6l-.679-.657-.015-1.3.618-.631c1.086-.013 1.093.529.667 1.295l.054.69a.543.543 0 01.023.685.5.5 0 01-.669-.08"
              data-name="Path 2103"
              transform="translate(-91.039 -26.08)"
            ></path>
            <path
              fill="#9be7bb"
              d="M246.576 57.393l-.651-.076q0-.317.01-.634a4.247 4.247 0 012.509-.622 1.151 1.151 0 01-1.257 1.279h-.308z"
              data-name="Path 2104"
              transform="translate(-90.32 -20.583)"
            ></path>
            <path
              fill="#68cd93"
              d="M237.924 67.065h1.259c.5.313.848 1.064.444 1.242-1 .438-1.264-.623-1.7-1.243"
              data-name="Path 2105"
              transform="translate(-87.381 -24.631)"
            ></path>
            <path
              fill="#7ae1a3"
              d="M243.182 74.16l-1.2-.6c.089-.451.011-1.19.733-.96.691.22.431 1 .469 1.56"
              data-name="Path 2106"
              transform="translate(-88.871 -26.648)"
            ></path>
            <path
              fill="#19243a"
              d="M415.523 275.418l-10.361 9.382a1.824 1.824 0 01-1.9.186l-2.136-1.907c.125-.77-.395-1.073-.942-1.443-1.971-1.331-1.489-3.491-.112-4.155 2.039-.984 2.376-2.645 3.135-4.254a38.254 38.254 0 016.616-5.512c.183-.115.464-.263.557-.166 2.229 2.285 4.692 4.425 5.145 7.871"
              data-name="Path 2107"
              transform="translate(-146.489 -98.249)"
            ></path>
            <path
              fill="#303844"
              d="M462.026 292.46a.4.4 0 00-.034.33c-4.043.068-8.088.165-12.133.177-.73 0-2.1.6-1.774-1.162l5.4-3.962c2.122.208 1 2.852 2.606 3.438 1.9.8 4.247-.652 5.932 1.179"
              data-name="Path 2108"
              transform="translate(-164.548 -105.714)"
            ></path>
            <path
              fill="#dba86f"
              d="M529.079 213.245a44.719 44.719 0 01-3.963 8.793c-1.649 3.119-2.845 6.474-4.36 9.668q-7.877 16.619-15.838 33.2c-1.222.584-2.518 1.548-3.212-.618l19.094-47.98a29.428 29.428 0 018.282-3.063"
              data-name="Path 2109"
              transform="translate(-184.259 -78.317)"
            ></path>
            <path
              fill="#8be3b0"
              d="M251.666 63.134l-.042-1.339c-.154-1.3-.992-2.718.625-3.724.005.8.034 1.594.009 2.39-.033 1.1.483 1.151 1.286.718a1.742 1.742 0 01-1.879 1.955"
              data-name="Path 2110"
              transform="translate(-92.283 -21.327)"
            ></path>
            <path
              fill="#c3f1d8"
              d="M256.142 67.716l-2.078 1.715c-.076.539-.44.456-.8.373l-.227-.293c.234-1.093.368-2.261 1.823-2.444a1.437 1.437 0 001.286.649"
              data-name="Path 2111"
              transform="translate(-92.93 -24.631)"
            ></path>
            <path
              fill="#5bcf8d"
              d="M249.528 70.5a1.353 1.353 0 00-.666-1.295 3.831 3.831 0 011.285-3.114c0 .208.009.415.022.622.361 1.259.729 2.516-.066 3.754q-.288.007-.574.033"
              data-name="Path 2112"
              transform="translate(-91.398 -24.272)"
            ></path>
            <path
              fill="#78e1a7"
              d="M250.822 70.826l.066-3.754c1.032.494.173 2.017 1.333 2.441l-.042.03a.934.934 0 01.025 1.274l-1.381.009"
              data-name="Path 2113"
              transform="translate(-92.118 -24.633)"
            ></path>
            <path
              fill="#c3f6da"
              d="M249.708 74.662q.047-.274.1-.548c.688-.04 1.432-.261 1.846.575l-1.265 1.293c-1.152.037-1-.6-.681-1.32"
              data-name="Path 2114"
              transform="translate(-91.624 -27.199)"
            ></path>
            <path
              fill="#5ed194"
              d="M252.99 72.189l-.025-1.274 1.074-.108.78.166a1.737 1.737 0 01-1.829 1.216"
              data-name="Path 2115"
              transform="translate(-92.905 -26.005)"
            ></path>
            <path
              fill="#a9e8c6"
              d="M231.51 57.08c.048.5.087 1 .593 1.291.028.191.053.383.075.575l-.018.676c-1.022.165-1.468-.242-1.271-1.284l.006-1.294a2.68 2.68 0 01.616.037"
              data-name="Path 2116"
              transform="translate(-84.78 -20.949)"
            ></path>
            <path
              fill="#67d296"
              d="M252.082 56.2c-1 1.11-.39 2.489-.624 3.726-1.185-1.551-.31-3.342-.583-5 .072-.709-.165-1.761.654-1.922.981-.194.387.9.657 1.355l-.1 1.841"
              data-name="Path 2117"
              transform="translate(-92.116 -19.459)"
            ></path>
            <path
              fill="#8fceab"
              d="M230.489 59.091l1.271 1.283-.066 1.41a2.322 2.322 0 01-1.937-1.973l.732-.719"
              data-name="Path 2118"
              transform="translate(-84.382 -21.702)"
            ></path>
            <path
              fill="#74d09d"
              d="M239.979 76.864l2.416.112c.342.145.95.244.985.443.2 1.136-1.24.654-1.5 1.4l-.681.074-1.272-1.283.054-.747"
              data-name="Path 2119"
              transform="translate(-88.116 -28.229)"
            ></path>
            <path
              fill="#d3dceb"
              d="M95.612 228.746c-.96-.977-2.188-.574-3.3-.576q-25.745-.037-51.491-.021a19.123 19.123 0 00-4.05.448c-2.962.635-3.774-.1-3.777-3.19q-.024-22.58-.008-45.16v-43.9c0-4.325 0-4.325 4.179-4.327l58.441-.02c4.651.14 4.415-.747 4.415 4.4v88.035c0 4.276-.006 4.276-4.412 4.3"
              data-name="Path 2120"
              transform="translate(-12.114 -48.481)"
            ></path>
            <path
              fill="#d3dceb"
              d="M66.373 13.082c10.012 0 20.025.079 30.035-.053 2.753-.036 3.759.82 3.639 3.614-.189 4.416-.1 8.848-.031 13.272.033 2.032-.793 2.8-2.819 2.8q-30.827-.058-61.653 0c-1.851 0-2.659-.488-2.614-2.487.109-4.844.127-9.695-.006-14.538-.059-2.153.791-2.659 2.78-2.644 10.222.075 20.445.035 30.668.034"
              data-name="Path 2121"
              transform="translate(-12.091 -4.785)"
            ></path>
            <path
              fill="#d3dceb"
              d="M66.5 72.645c-10.217 0-20.434-.047-30.65.039-2.125.018-3.015-.516-2.94-2.813.154-4.733.136-9.477.008-14.212C32.862 53.521 33.7 53 35.694 53q30.808.084 61.616 0c2.053-.006 2.778.62 2.723 2.7q-.186 6.944 0 13.9c.061 2.382-.919 3.1-3.193 3.078-10.11-.078-20.222-.034-30.333-.034"
              data-name="Path 2122"
              transform="translate(-12.086 -19.466)"
            ></path>
            <path
              fill="#d3dceb"
              d="M99.37 111.086c-21.016-.008-42.03-.055-63.045.027-2.53.01-3.533-.562-3.429-3.286.2-5.245.047-10.5.04-15.754 1.389-.866 2.946-.559 4.448-.637 3.759-.185 7.454-1.034 11.234-1.029q20.7.022 41.406-.012a24.125 24.125 0 018.076 1.038 1.833 1.833 0 011.879 2.038q-.033 8.424-.117 16.848c0 .258-.32.511-.49.767"
              data-name="Path 2123"
              transform="translate(-12.079 -33.198)"
            ></path>
            <path
              fill="#b8becc"
              d="M100.708 89.37H39.994c4.466-.43 8.292-2.675 12.349-4.285a3.409 3.409 0 013.356.268c1.986 1.672 4.277 1.505 6.6 1.5 9.592-.015 19.185.068 28.775-.046 3.509-.042 6.878-.015 9.638 2.558"
              data-name="Path 2124"
              transform="translate(-14.688 -31.135)"
            ></path>
            <path
              fill="#b2bbcb"
              d="M38.145 51.3H100.6v.316H38.241l-.1-.316"
              data-name="Path 2125"
              transform="translate(-14.009 -18.84)"
            ></path>
            <path
              fill="#b3bcc9"
              d="M105.556 45.762H50.313v-.315h55.371l-.127.315"
              data-name="Path 2126"
              transform="translate(-18.478 -16.691)"
            ></path>
            <path
              fill="#1f2a3c"
              d="M587.51 196.789a15.373 15.373 0 01-6.21 1.3c-1.62.493-3.3.025-4.935.329a1.524 1.524 0 01-1-.409c1.228-1.345 3.013-.1 4.5-.979-1.911-.922-5.625 1.2-5.25-3.09.161-1.835 1.754-.657 2.642-.993l-.174.881c3.171-.976 4.3 3.054 7.132 2.909a1.01 1.01 0 01-.537.269c-.37.058-.745.03-1.118.055.278 0 .555.011.832 0a1.139 1.139 0 00.827-.319l3.286.047"
              data-name="Path 2127"
              transform="translate(-211.027 -70.838)"
            ></path>
            <path
              fill="#252129"
              d="M481.61 273.042c.512-.667-.512-2.381.9-2.154 1.856.3-.056 1.354.066 2.021.279 1.525.764 3.012 1.165 4.515l-.695 3.179c-1.544-2.318-1.341-4.968-1.438-7.561"
              data-name="Path 2128"
              transform="translate(-176.878 -99.48)"
            ></path>
            <path
              fill="#273244"
              d="M565.8 198.42l5.3.084c-3.6 1.223-7.37 1.005-11.075 1.367-4.419-.32-8.9-.049-13.2-1.467 1.65-1.327 3.576-.244 6.3-.738-2.825-.485-5.076-.745-4.405-3.66l4.422.021c-.7.753-1.126 1.26.487 1.281 1.01.013 2.672-.756 2.922.784.208 1.28-1.749.706-2.444 1.579 1.777 1.611 3.92 1.392 6.019 1.364 1.756-1.446 3.84.127 5.673-.615"
              data-name="Path 2129"
              transform="translate(-200.832 -71.252)"
            ></path>
            <path
              fill="#1b222e"
              d="M573.508 200.773c-1.783 1.2-3.788.366-5.673.615q-.019-.3-.021-.607a6.932 6.932 0 014.423-.011l.638.007h.633"
              data-name="Path 2130"
              transform="translate(-208.538 -73.604)"
            ></path>
            <path
              fill="#273244"
              d="M572.237 200.546l-4.423.011a3.642 3.642 0 014.423-.011"
              data-name="Path 2131"
              transform="translate(-208.538 -73.381)"
            ></path>
            <path
              fill="#2167bc"
              d="M421.88 257.6q-2.853-3.851-5.7-7.7a3.582 3.582 0 011.343-2.706c9.783-9.6 19.607-19.166 29.934-28.192 1.434 5.152 1.965 10.459 2.723 15.727-.358 1.265.476 2.736-.667 3.865-.592-.85-.175-1.827-.338-2.732.147.907-.3 1.889.337 2.735l.078.808q-9.22 6.484-18.439 12.972c-1.856 1.309-3.716 2.616-5.517 4a5.015 5.015 0 01-3.75 1.227"
              data-name="Path 2132"
              transform="translate(-152.846 -80.43)"
            ></path>
            <path
              fill="#1f293c"
              d="M398.734 276.371c.026 1.052.065 2.1.073 3.157.007.835-.358 1.693-1.242 1.348-1.781-.694-1.9.558-2.285 1.617-.613 1.693.886 1.422 1.676 1.939.9.591 1.437 1.474-.3 1.791a87.665 87.665 0 01-9.954-6.853c-.108-1.975 1.076-2.751 2.807-2.9a34.885 34.885 0 004-.394c1.373.392 2.838-.011 4.2.488l1.033-.2"
              data-name="Path 2133"
              transform="translate(-142.018 -101.394)"
            ></path>
            <path
              fill="#292d37"
              d="M395.135 275.995l-4.584.056c-3.138.083-6.213 1.148-9.391.6-.657-.295-1.554-.577-1.445-1.383.1-.723 1.024-.535 1.6-.568 4.668-.258 9.342-.522 13.819 1.291"
              data-name="Path 2134"
              transform="translate(-139.452 -100.821)"
            ></path>
            <path
              fill="#2c3441"
              d="M382 277.524c3.076-1.04 6.258-.452 9.391-.6a2.106 2.106 0 01-2.274.6 3.543 3.543 0 00-4.144 2.148L382 277.524"
              data-name="Path 2135"
              transform="translate(-140.296 -101.691)"
            ></path>
            <path
              fill="#1e283b"
              d="M458.669 285.042c-1.377-.911-1.131-2.673-2.016-3.842.309-.27.573-.651.931-.792 4.61-1.81 8.3-4.4 8.651-9.918.382-.3.564-1.022 1.284-.607l.269 1.264q-.1.55-.192 1.1c.308.976.419 2 .678 2.983.257.507.047 1.172.54 1.6.159.448-.467 1.233.562 1.307l-.031 2.482a.526.526 0 01-.6.123 7.209 7.209 0 00.468 2.516c.163.886.245 1.734-.866 2.087-3.227-.153-6.472.37-9.678-.3"
              data-name="Path 2136"
              transform="translate(-167.712 -99.073)"
            ></path>
            <path
              fill="#413938"
              d="M473.082 269.111l-1.284.607.186-1.842c1.677-.752 1 .584 1.1 1.235"
              data-name="Path 2137"
              transform="translate(-173.275 -98.299)"
            ></path>
            <path
              fill="#121a2e"
              d="M459.785 293.751l10.107-.032a.882.882 0 011.266.039c-1.41 1.569-3.241.471-4.852.768-2.154-.089-4.308-.175-6.461-.274-.058 0-.147-.134-.153-.209a.822.822 0 01.092-.292"
              data-name="Path 2138"
              transform="translate(-168.829 -107.781)"
            ></path>
            <path
              fill="#1e2131"
              d="M476.9 291.353l-1.266-.038.016-2.494a1.565 1.565 0 010-1.9h.551l.7 4.43"
              data-name="Path 2139"
              transform="translate(-174.573 -105.377)"
            ></path>
            <path
              fill="#30292c"
              d="M474.459 277.038c-1.03-.973-.506-2.207-.561-3.344a1.044 1.044 0 01.618 1.3 1.924 1.924 0 01-.057 2.046"
              data-name="Path 2140"
              transform="translate(-174.014 -100.518)"
            ></path>
            <path
              fill="#32333c"
              d="M474.834 277.792l.056-2.046a5.089 5.089 0 01.6 3.284 1.275 1.275 0 01-.658-1.238"
              data-name="Path 2141"
              transform="translate(-174.39 -101.272)"
            ></path>
            <path
              fill="#84dea8"
              d="M249.486 75.013c.08.516.11 1.057.681 1.319l-.644 1.264-.649-.046.066-2.48q.274-.016.545-.058"
              data-name="Path 2142"
              transform="translate(-91.403 -27.55)"
            ></path>
            <path
              fill="#fcfcfd"
              d="M80.784 149.037c-2.094 0-4.19-.049-6.282.013-1.917.058-2.506-.873-2.582-2.685-.085-2.073.912-2.432 2.673-2.4 4.082.081 8.168.058 12.252.012 1.724-.019 2.788.426 2.831 2.43.046 2.142-1.021 2.719-2.924 2.645-1.986-.077-3.979-.017-5.968-.018"
              data-name="Path 2143"
              transform="translate(-26.412 -52.874)"
            ></path>
            <path
              fill="#fcfefd"
              d="M80.646 29.53c-2.1 0-4.2-.074-6.3.023-1.736.08-2.448-.528-2.423-2.337.023-1.674.7-2.18 2.277-2.159q6.611.091 13.223 0c1.591-.023 2.24.512 2.268 2.17.031 1.824-.718 2.4-2.438 2.325-2.2-.093-4.407-.022-6.611-.022"
              data-name="Path 2144"
              transform="translate(-26.416 -9.203)"
            ></path>
            <path
              fill="#fcfdfc"
              d="M80.6 69.152c-2.1 0-4.205-.014-6.308.005-1.24.011-2.291-.043-2.342-1.749-.049-1.65.2-3.14 2.117-3.194 4.621-.13 9.248-.1 13.871-.038 1.545.021 1.708 1.248 1.725 2.5.02 1.481-.465 2.465-2.125 2.466h-6.939v.012"
              data-name="Path 2145"
              transform="translate(-26.422 -23.55)"
            ></path>
            <path
              fill="#fcfdfd"
              d="M80.611 109.074c-1.888 0-3.78-.077-5.662.021-2.109.109-3.029-.646-3.033-2.886-.005-2.269 1.313-2.2 2.874-2.188q6.136.048 12.271 0c1.51-.015 2.635.077 2.633 2.108 0 1.839-.709 2.826-2.477 2.9-2.2.091-4.4.022-6.606.022z"
              data-name="Path 2146"
              transform="translate(-26.412 -38.202)"
            ></path>
            <path
              fill="#1e232f"
              d="M588.293 198.973c-.727.816-1.583.754-2.621.371.879-.68 1.792-.232 2.616-.376v.005"
              data-name="Path 2147"
              transform="translate(-215.096 -73.069)"
            ></path>
            <path
              fill="#1769c6"
              d="M465.87 232.077c.929 1.6.479 2.664.6 4.308-.929-1.632-.491-2.692-.6-4.308"
              data-name="Path 2148"
              transform="translate(-171.093 -85.234)"
            ></path>
            <path
              fill="#1867c3"
              d="M468.506 248.154c-1.086-.917-.463-2.041 0-3.124v3.124"
              data-name="Path 2149"
              transform="translate(-171.844 -89.991)"
            ></path>
            <path
              fill="#141932"
              d="M475.456 286.161v1.9c-1.021-.933-.576-2.082-.516-3.212.721.269.425.864.52 1.314"
              data-name="Path 2150"
              transform="translate(-174.373 -104.614)"
            ></path>
          </g>
        </g>
        <text
          fill="#d3dceb"
          data-name="OOPS!"
          fontFamily="ESKlarheitGrotesk-Bd, Proxima Nova"
          fontSize="34"
          fontWeight="700"
          transform="translate(731 269)"
        >
          <tspan x="0" y="0">
            OOPS!
          </tspan>
        </text>
      </g>
    </svg>
  );
};

export default PageNotFoundBg;
